import * as React from 'react';
import { useState, useEffect} from 'react';
import Select from 'react-select'
import { NumericFormat } from 'react-number-format';
import { bdAxios } from '../../components/utils/Axios';
import { parseJwt, getToken } from '../../components/utils/Common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Note from '../../components/Note'; 


const RatioForm = (data: any) => {
    const [page, setPage] = useState<number>(0)
    const [year, setYear] = useState<any>(false)
    const [optYears, setOptYears] = useState<any>([])
    const [prelevements, setPrelevements] = useState<number>(0)

    const [officeId, setOfficeId] = useState<any>()
    const [savedRatioId, setSavedRatioId] = useState<number>(0)
    const [configs, setConfigs] = useState<any>()
    const [selectedOfficeOption, setSelectedOfficeOption] = useState<any>()
    const [offices, setOffices] = useState<Array<any>>([]);
    const [officeOptions, setOfficeOptions] = useState<any>([])

    const [formData, setFormData] = useState<any>({})
    const [lastUpdated, setLastUpdated] = useState<string>('')
    const [isEditing, setIsEditing] = useState<boolean>(false)

    const [nbEmployers, setNbEmployers] = useState<number>(0)

    const [ca, setCa] = useState<number>(0)
    const [honoraires, setHonoraires] = useState<number>(0)
    const [facturation, setFacturation] = useState<number>(0)

    const [salary, setSalary] = useState<number>(0);
    const [notaryAssocSalary, setNotaryAssocSalary] = useState<number>(0)
    const [notarySalary, setNotarySalary] = useState<number>(0)

    const [regularExpenses, setRegularExpenses] = useState<number>(0);
    const [otherExpenses, setOtherExpenses] = useState<number>(0)
    const [totalDiverseExpenses, setTotalDiverseExpenses] = useState<number>(0)
    const [balanceExpenses, setBalanceExpenses] = useState<number>(0)
    const [totalExpenses, setTotalExpenses] = useState<number>(0)

    const [coutsFixes, setCoutsFixes] = useState<number>(0)
    const [coutsVariables, setCoutsVariables] = useState<number>(0)

    const [revImmobilier, setRevImmobilier] = useState<number>(0)
    const [revBusiness, setRevBusiness] = useState<number>(0)
    const [revIndiv, setRevIndiv] = useState<number>(0)
    const [revExpertises, setRevExpertises] = useState<number>(0)

    const [seuilRentabilite, setSeuilRentabilite] = useState<number>(0)

    const [ratioExists, setRatioExists] = useState<boolean>(false)

    
    const [ratioLabels, setRatioLabels] = useState<any[]>([]);
    const [defaultRatio, setDefaultRatio] = useState<any>({});
    const [displayRatios, setDisplayRatios] = useState<Record<string, any>>({});

    const [honorairesProfAvTaxes, setHonorairesProfAvTaxes] = useState<number>(0);
    const [deboursesTaxables, setDeboursesTaxables] = useState<number>(0);
    const [deboursesNonTaxables, setDeboursesNonTaxables] = useState<number>(0);
    const [chiffreAffairesAvTaxesTotal, setChiffreAffairesAvTaxesTotal] = useState<number>(0);

    const [facturationTotal, setFacturationTotal] = useState<number>(0);
    const [prelevAssoDiviActionnaires, setPrelevAssoDiviActionnaires] = useState<number>(0);
    const [beneficesNetsAvPrelevDiviTotal, setBeneficesNetsAvPrelevDiviTotal] = useState<number>(0);
    const [beneficesNetsTotal, setBeneficesNetsTotal] = useState<number>(0);

    const [isLegacyVisible, setIsLegacyVisible] = useState<boolean>(false);
    const [isFacturationLegacyVisible, setIsFacturationLegacyVisible] = useState<boolean>(false);
    const [isHonorairesLegacyVisible, setIsHonorairesLegacyVisible] = useState<boolean>(false);

    const pages: any = [
        { 'label': 'Identification', index: 0 },
        { 'label': 'Statistiques RH', index: 1 },
        { 'label': 'Profil financier', index: 2 },
        { 'label': 'Salaires', index: 3 },
        { 'label': 'Frais d’exploitation', index: 4 },
        { 'label': 'Dépenses Diverses', index: 5 },
        { 'label': 'États financiers', index: 6 },
        { 'label': 'Droit Immobilier', index: 7 },
        { 'label': 'Droit des affaires', index: 8 },
        { 'label': 'Droit de la personne', index: 9 },
        { 'label': 'Expertises sectorielles', index: 10 },
        { 'label': 'Statistiques salariales', index: 11 },
        { 'label': 'Tarification', index: 12 },
        { 'label': 'Indicateurs de performance', index: 13 },
    ];



    const getSeuil = () => {
        let upperPart: number = ca * coutsFixes

        let lowerPart: number = ca - coutsVariables

        setSeuilRentabilite(upperPart / lowerPart);
    }

    /**
     * Update formData for key and value
     * 
     * @param name 
     * @param value 
     */
    const setValue = async (name: string, value: any, update: string = '') => {

        let fValue = numericToFloat(value);

        let d: any = { ...formData, [name]: fValue };

        //setFormData(d);
        const v = await setLastUpdated(update)
        const u = await setFormData(d)

        switch (name) {
            case 'chiffre_affaires':
                setCa(fValue)
                break
            case 'honoraires':
                setHonoraires(fValue)
                break
            case 'facturation':
                setFacturation(fValue)
                break;
            case 'salaire_notaires_salaries':
                setNotarySalary(fValue)
                break
            case 'totalExpenses':
                setTotalExpenses(fValue)
                break
            case 'salaire_notaires_associes':
                setNotaryAssocSalary(fValue)
                break;
            case 'honoraires_prof_av_taxes':
                setHonorairesProfAvTaxes(fValue);
                break;
            case 'debourses_taxables':
                setDeboursesTaxables(fValue);
                break;
            case 'debourses_non_taxables':
                setDeboursesNonTaxables(fValue);
                break;
            case 'prelev_asso_divi_actionnaires':
                setPrelevAssoDiviActionnaires(fValue);
                break;        
            case 'nb_notaires_salaries':
            case 'depense_loyer':
            case 'depense_inters_prets_marge':
            case 'depense_amortissement':
                break;
            case 'salary':
            case 'depense_debourses_dossiers':
            case 'depense_telecom':
            case 'depense_publicite':
                break;

        }
    }

    /**
     * Run calculation after formData is updated
     */
    useEffect(() => {

        let s = updateSalary()
        setSalary(s);

        let dep = updateRegularExpenses()
        setRegularExpenses(dep)

        //let other = updateOtherExpenses()
        let diverseExpenses = updateDiverseExpenses()
        //setOtherExpenses(otherExpenses)
        setTotalDiverseExpenses(diverseExpenses);
        
        let sumOtherDiverseExpenses = updateSumOtherDiverseExpenses();
        setOtherExpenses(sumOtherDiverseExpenses);

    }, [formData]);

    useEffect(() => {

        //let balance = totalExpenses + (salary + otherExpenses + totalDiverseExpenses + regularExpenses);
        let balance = salary + otherExpenses + totalDiverseExpenses + regularExpenses;
        setBalanceExpenses(balance)

        let cf = updateCoutsFixes()
        let cv = updateCoutsVariables()
        setCoutsFixes(cf)
        setCoutsVariables(cv)

        getSeuil()

    }, [totalExpenses, regularExpenses, otherExpenses, totalDiverseExpenses, salary])



    const getValue = (propName: string) => {
        if (formData.hasOwnProperty(propName)) {
            let value = numericToFloat(formData[propName]);
            return value;
        }

        return '';
    }

    const getSum = (keys: Array<string>) => {
        let s = 0.00;
        keys.forEach((key: string) => {
            let v = parseFloat(formData[key]) ?? 0;
            s += isNaN(v) ? 0 : v
        });
        s = Number(s.toFixed(2))
        return s
    }

    const getNumValue = (key: string) => {
        let v = getValue(key)
        let f = parseFloat(v)
        return f
    }

    const updateCoutsFixes = () => {
        let s = getSum([
            'depense_loyer',
            'depense_amortissement',
            'depense_inters_prets_marge'
        ])
        //s += formData.nb_notaires_associes * prelevements
        return s
    }

    const updateCoutsVariables = () => {
        let s = getSum([
            'depense_debourses_dossiers',
            'depense_telecom',
            'depense_publicite',
            'depense_firme_comptable',
            'depense_charges_sociales',
            'depense_assurance_responsabilite',
            'depense_cotisation_professionnelle',
            'depense_formation',
            'depense_mauvaises_creances',
            'autres_depenses'
        ])
        s += salary
        return s
    }


    const updateRegularExpenses = () => {
        return getSum([
            'depense_loyer',
            'depense_amortissement',
            'depense_debourses_dossiers',
            'depense_inters_prets_marge',
            'depense_assurance_bureau_cyberassurance',
            'depense_cyberassurance',
            'depense_telecom',
            'depense_fournitures_de_bureau',
            'depense_equip_informatique',
            'depense_frais_pmeinter',
        ])

    }

    const updateOtherExpenses = () => {

        return getSum([
            'depense_firme_comptable',
            'depense_publicite',
            'depense_assurance_responsabilite',
            'depense_cotisation_professionnelle',
            'depense_formation',
            'depense_mauvaises_creances'
        ]);

    }

    const updateSumOtherDiverseExpenses = () => {

        return getSum([
            //'totalOtherExpenses',
            'otherExpenses',
        ]);
    }

    const updateDiverseExpenses = () => {

        return getSum([
            'depense_firme_comptable',
            'depense_publicite',
            'depense_assurance_responsabilite',
            'depense_cotisation_professionnelle',
            'depense_formation',
            'depense_mauvaises_creances'
        ]);

    }

    const updateSalary = () => {

        return getSum([
            'salaire_notaires_associes',
            'salaire_notaires_salaries',
            'salaire_coll',
            'salaire_avocats',
            'salaire_stagiaires',
            'salaire_saisonniers',
            'salaire_autres',
            'depense_charges_sociales',
        ])
    }

    const updateBusiness = () => {

        return getSum([
            'service_corporatif',
            'corporatif',
            'corporatif_autre'
        ]);

    }

    const updateRevImmobilier = () => {
        return getSum([
            'immobilier_residentiel',
            'immobilier_comm_ind',
            'immobilier_autre'

        ]);
    }

  /*  const updateIndiv = () => {
        return getSum([
            'testaments_mandats',
            'donations_fiduciaires',
            'successions',
            'autres_personne_familial',
        ])

    }*/
    const updateIndiv = () => {
        return getSum([
            'testaments_mandats',
            'successions',
            'autres_personne_familial',
        ])

    }
    const updateExpertises = () => {
        return getSum([
            'agricole',
            'exp_maritime',
            'donations_fiduciaires',
            'exp_autres'
        ])
    }





    const getIsActive = (pageToCheck: any) => {
        if (page === pageToCheck) {
            return "active";
        }

        return "";
    }


    // initial state
    useEffect(() => {
        let token = getToken();
        if (!token) {
            return;
        }

        if (data.selectedRatio) {
            setIsEditing(true);
            for (let key in data.selectedRatio.data) {
                setValue(key, data.selectedRatio.data[key]);
            }
        }


        bdAxios.get('ratios/configs', {
            headers: {
                'Authorization': "Bearer " + token
            }
        }).then((r: any) => {
            setConfigs(r.data.configs);
            let found = false;
            let today = new Date().getTime()
            let editableYears: any = []
            r.data.configs.ratios.map((yrl: any) => {

                let endDate = new Date(yrl.end_date).getTime()
                let startDate = new Date(yrl.start_date).getTime()

                if (yrl.opened && today < endDate && today > startDate) {
                    editableYears.push({ label: yrl.year.toString(), value: parseInt(yrl.year) })
                }

                if (parseInt(yrl.year) === year && yrl.opened) {
                    setPrelevements(parseFloat(yrl.retainer));

                    found = true;
                }
            });

            setOptYears(editableYears)

            if (!found) {
                //setPrelevements(0);
            }

        });





        bdAxios.get('myoffices?light=1', {
            headers: {
                'Authorization': "Bearer " + token
            }
        }).then((r: any) => {
            r.data.offices.sort((a: any, b: any) => {
                return a.post_title.localeCompare(b.post_title);
            });

            setOffices(r.data.offices);

            const offOpt: Array<object> = [];
            for (let i in r.data.offices) {
                offOpt.push({ label: r.data.offices[i].post_title, value: r.data.offices[i].ID })
            }

            setOfficeOptions(offOpt);

            if (data?.selectedRatio) {
                r.data.offices.map((office: any) => {
                    if (office.ID == data.selectedRatio.data.office) {
                        setSelectedOfficeOption([{ label: office.post_title, value: office.ID }])
                    }
                })
            }
        });

    }, []);

    /** 
     * initial form fields state 
     * note : this will call the wp_ratiometa_labels table. 
     * we will use this based on the labels in the db 
     * to set the default values on new ratios entries 
     * important the field most be in the wp_ratiometa_labels table
     * for this to work
     * -- fixrs
     */ 

    //helper function :
    const buildDefaultRatio = (labels: any[]) => {
        const obj: any = {}

        labels.forEach(label => {
            if (!label.meta_key) return; // use meta_key instead of key

            const key = label.meta_key;

            if (label.type === 'number') obj[key] = 0;
            else if (label.type === 'date') obj[key] = null;
            else obj[key] = '';
        });

        return obj;
    };

    //build the default ratio object:
   useEffect(() => {
        let token = getToken() ?? '';
        if (!token) return;

        bdAxios.get('ratios/labels', { headers: { Authorization: "Bearer " + token } })
            .then((r: any) => {
                setRatioLabels(r.data);
                setDefaultRatio(buildDefaultRatio(r.data)); // build default once
            });
    }, []);

    //helper function : for display labels in the form
    
    useEffect(() => {
        // only run when ratioLabels changes
        const obj: Record<string, any> = {};
        Object.values(ratioLabels).forEach((item: any) => {
            obj[item.meta_key] = item;
        });
        setDisplayRatios(obj);
    }, [ratioLabels]); 

    /**
     * Get Ratio from DB if Year and Office ID are changed
     */
    useEffect(() => {
        // if year and officeId not set, early bail
         if (!year || !officeId || !defaultRatio) return;


        let token = (getToken() ? getToken() : '');
        if (token === null) {
            return;
        }

        data = { selectedRatio: { data: {} } }

        bdAxios.get('ratios/get', {
            headers: {
                'Authorization': "Bearer " + token
            },
            params: {
                year: year,
                officeId: officeId,
                forEditing: true
            }
        }).then((r: any) => {


            if (r.data.success) {
                //let ratioData = JSON.parse(r.data.data.ratio)
                let ratioData = r.data.data.ratio

                ratioData.user_name = ratioData.nom_utilisateur
                ratioData.user_phone = ratioData.phone_utilisateur
                ratioData.user_email = ratioData.email_utilisateur

                data.selectedRatio.data = ratioData

                if (data.selectedRatio) {

                    // set prelevement
                    configs.ratios.map((yrl: any) => {
                        if (parseInt(yrl.year) === year) {
                            setPrelevements(yrl.retainer)
                        }
                    });
                    setIsEditing(true);

                    //triggers a bunch of updates
                    setFormData(ratioData);

                    setChiffreAffairesAvTaxesTotal(Number(ratioData.chiffre_affaires) || 0);
                    setFacturationTotal(Number(ratioData.facturation_total) || Number(ratioData.facturation) || 0);
                    setBeneficesNetsTotal(Number(ratioData.benefices_nets_total) || Number(ratioData.benefices_nets) || 0);

                    setNotaryAssocSalary(ratioData.salaire_notaires_associes || 0);
                    setRevImmobilier(ratioData.immobilier_total || 0);
                    setRevBusiness(ratioData.commercial_corporatif || 0);
                    setRevIndiv(ratioData.personne_succession_familial || 0); // Corrected setter name
                    setRevExpertises(ratioData.exp_total || 0);
                    setCa(ratioData.chiffre_affaires || 0);

                }
                setRatioExists(true);
                
            } else if (r.data.message?.includes("Aucun ratio")) {
                // No data for this year → reset the form
                if (!savedRatioId) {
                    setRatioExists(false);
                    if (!defaultRatio) return

                    setFormData({
                        ...defaultRatio,
                        nom_utilisateur: '',
                        phone_utilisateur: '',
                        email_utilisateur: '',
                    });
                    setNotaryAssocSalary(0)
                    setCa(0)
                    setRevImmobilier(0)
                    setRevBusiness(0)
                    setRevExpertises(0)
                    setPrelevements(0)
                    setIsEditing(false)
                    alert(r.data.message)
                }
            } else {
                alert(r.data.message)
                setRatioExists(false);
            }

        });



    }, [year, officeId, defaultRatio, savedRatioId]);

    useEffect(() => {
        // 1. Calculations for 203 / 205
        const valHonorairesProf = Number(formData.honoraires_prof_av_taxes) || 0;
        const valDeboursesTax = Number(formData.debourses_taxables) || 0;
        const valDeboursesNonTax = Number(formData.debourses_non_taxables) || 0;

        // Use the locally calculated sum immediately
        const caAvTaxesCalc = valHonorairesProf + valDeboursesTax + valDeboursesNonTax;
        
        setChiffreAffairesAvTaxesTotal(caAvTaxesCalc);
        
        // Sync 205: Other legacy calculations depend on this field
        setValue('chiffre_affaires', caAvTaxesCalc);
        
        // 2. Calculation for 204 (Facturation total)
        const facturationTotalCalc = ((valHonorairesProf + valDeboursesTax) * 1.14975) + valDeboursesNonTax;
        setFacturationTotal(facturationTotalCalc);

        // 3. Calculations for 207.2 (Bénéfices nets avant prélèvements)
        const valTotalExp = Number(formData.totalExpenses) || 0;
        const valPrelev = Number(prelevAssoDiviActionnaires) || 0;
        
        const beneficesNetsAvPrelevCalc = caAvTaxesCalc - valTotalExp - valPrelev;
        setBeneficesNetsAvPrelevDiviTotal(beneficesNetsAvPrelevCalc);

        // 4. Calculation for 207 (Bénéfices nets totaux)
        setBeneficesNetsTotal(valPrelev + beneficesNetsAvPrelevCalc);

    }, [
        formData.honoraires_prof_av_taxes, 
        formData.debourses_taxables, 
        formData.debourses_non_taxables, 
        // We removed formData.chiffre_affaires_av_taxes from here because 
        // it is now a result of the calculation, not a source input.
        formData.totalExpenses, 
        prelevAssoDiviActionnaires
    ]);


    const getPageClassName = (testedPage: number, isNumberPage: boolean = false) => {
        let cname: string = (page === testedPage ? 'active' : 'hidden');
        if (isNumberPage) {
            cname += ' number-fields-only'
        }

        return cname;
    }

    const getSelectedValue = (key: string, defaultV?: any) => {
        if (!data.selectedRatio) {
            if (defaultV) {
                return defaultV;
            }
            return '';
        }

        if (data.selectedRatio.data.hasOwnProperty(key)) {
            if (data.selectedRatio.data[key] instanceof String) {
                return (data.selectedRatio.data[key]);
            } else {
                return parseInt(data.selectedRatio.data[key]);
            }
        }

        if (defaultV) {
            return defaultV;
        }
        return 0;

    }
    const numericToFloat = (val: string): any => {
        if (false == /^[0-9 $,.]*$/.test(val)) {
            return val
        }
        if (typeof (val) == 'string') {
            val = val.replaceAll(/[ $]/g, '')
            val = val.replaceAll(',', '.')
        }

        return parseFloat(val)
    }
    const submit = (lpage: number) => {

        if (!officeId || !year) {
            alert('Veuillez choisir une étude et une année avant de continuer.');
            return;
        }

        const form: any = document.getElementById('ratioForm');
        const yearInput: any = document.querySelector("[name=year]");
        //const formData = new FormData(form);

        formData.etude_id = officeId
        formData.year = year

        //formData.chiffre_affaires = ca
        const ca = chiffreAffairesAvTaxesTotal;
        formData.chiffre_affaires = ca;
        formData.chiffre_affaires_av_taxes = ca;

        // const facturation = facturationTotal;
        formData.facturation_total = facturationTotal;

        const benefices_nets = beneficesNetsTotal;
        formData.benefices_nets_total = beneficesNetsTotal;
        
        
        
        formData.honoraires = honoraires
        formData.honoraires_prof_av_taxes = honorairesProfAvTaxes;
        formData.debourses_taxables = deboursesTaxables;
        formData.debourses_non_taxables = deboursesNonTaxables;
        //formData.chiffre_affaires_av_taxes = chiffreAffairesAvTaxesTotal;
        
        
        formData.prelev_asso_divi_actionnaires = prelevAssoDiviActionnaires;
        formData.beneficesNets_av_prelevements_dividendes_total = beneficesNetsAvPrelevDiviTotal;

        

        // keep legacy current values for bk
        formData.facturation = facturation
        formData.salaire_notaires_salaries = notarySalary


        formData.regularExpenses = regularExpenses
        //formData.otherExpenses = otherExpenses
        formData.totalOtherExpenses = totalDiverseExpenses
        formData.balanceExpenses = balanceExpenses
        formData.totalExpenses = totalExpenses

        formData.salaires = updateSalary()
        formData.immobilier_total = updateRevImmobilier()
        formData.commercial_corporatif = updateBusiness()
        formData.exp_total = updateExpertises()
        formData.personne_succession_familial = updateIndiv()

        // calculations
        formData.seuil_rentabilite = seuilRentabilite;
        formData.ca_benefits = totalExpenses - notaryAssocSalary;
        formData.dossier_par_mois = formData.nb_dossiers / 12;
        formData.minutes_par_mois = formData.nb_minutes / 12;

        if (ca) {
            formData.benefits_bprel = benefices_nets / ca;
            formData.point_mort = (seuilRentabilite * 360) / ca;
            formData.perc_salary = salary / ca;
            formData.perc_notaries = notarySalary / ca;
        }
        if (formData.total_passifs) {
            formData.fond_roulement = formData.total_actifs / formData.total_passifs;
        }
        if (ca) {
            formData.perc_recevable = formData.recevables / ca;
        }

        if (facturationTotal) {
            formData.delay_percept = (formData.recevables / facturationTotal) * 365;
            formData.tec_sur_facturation_pourcent = formData.travaux_en_cours / facturationTotal;
        }

        if (formData.nb_notaires_salaries) {
            formData.avg_notary = notarySalary / formData.nb_notaires_salaries;
        }

        let nb_notaires = formData.nb_notaires_associes + formData.nb_notaires_salaries;
        if (nb_notaires) {
            formData.dossiers_par_notaire_par_annee = formData.nb_dossiers / nb_notaires;
            formData.minutes_par_notaire_par_annee = formData.nb_minutes / nb_notaires;
            formData.collab_par_notaire = formData.nb_employes / nb_notaires;
            formData.cost_per_hour = (totalExpenses - formData.depense_debourses_dossiers) / ((formData.nb_minutes / 60) * nb_notaires);
            formData.chiffre_affaires_par_notaire = ca / nb_notaires;
        }
        if (formData.nb_dossiers) {
            formData.cout_moyen_par_dossier = totalExpenses / formData.nb_dossiers;
            formData.chiffre_affaires_par_dossier = ca / formData.nb_dossiers;
        }
        if (formData.nb_employes) {
            formData.chiffre_affaires_par_collabo = ca / formData.nb_employes;
            //formData.taux_de_roulement = formData.nb_employes_depart / formData.nb_employes;
            formData.taux_de_roulement = formData.nb_employes_depart / (formData.nb_notaires_associes + formData.nb_notaires_salaries + formData.nb_employes + formData.nb_avocats + formData.nb_saisonniers + formData.nb_autre);
            formData.avg_collab = formData.salaire_coll / formData.nb_employes;
        }
        if (formData.nb_minutes) {
            formData.chiffre_affaires_par_min = ca / formData.nb_minutes;
            formData.avg_rate_by_hour = ca / formData.nb_minutes / 60;
        }

        let token = (getToken() ? getToken() : '');
        if (token === null) {
            return;
        }
        const user = parseJwt(token);

        if (user.data.roles && Array.isArray(user.data.roles)) {

        } else {

        }
        
        // Set complete_date: use current form value if exists, otherwise now
        if (!formData.complete_date) {
            const now = new Date();
            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, '0');
            const dd = String(now.getDate()).padStart(2, '0');
            const hh = String(now.getHours()).padStart(2, '0');
            const mi = String(now.getMinutes()).padStart(2, '0');
            const ss = String(now.getSeconds()).padStart(2, '0');

            formData.complete_date = `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
        }

        if (formData.modified_date) {
            const now = new Date();
            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, '0');
            const dd = String(now.getDate()).padStart(2, '0');
            const hh = String(now.getHours()).padStart(2, '0');
            const mi = String(now.getMinutes()).padStart(2, '0');
            const ss = String(now.getSeconds()).padStart(2, '0');

            formData.modified_date = `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
        }


        bdAxios.post('create/ratio', formData,
            {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((r: any) => {
                setPage(lpage);
                setSavedRatioId(r.data.ratio_id)
            })
            .catch((err: any) => console.error(err))
    }

    const exportRatio = () => {
        let token = (getToken() ? getToken() : '');
        if (token === null) {
            return;
        }
        const formData: FormData = new FormData();
        formData.append('ratio_id', savedRatioId + '');

        bdAxios.post('ratios/export', formData,
            {
                headers: {
                    'Authorization': "Bearer " + token
                },
                responseType: 'blob'
            }).then((r: any) => {
                let i: any = document.querySelector("[name=etude_id]");
                const office_name = officeOptions.find((item: { value: string; label: string }) => item.value == i.value)?.label || 'etude-inconnue';
                const url = window.URL.createObjectURL(new Blob([r.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Export Ratio-' + office_name + '-' + year + '.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err: any) => console.error(err))
    }

    const maybeSetPage = (lpage: number) => {
        if (page === pages.length - 1) {
            return false;
        }
        if (!ratioExists) {
            alert("Veuillez créer un ratio avant de naviguer vers les autres pages.")
            return
        }

        setPage(lpage);
    }

    useEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, [page]);

    /**
     * numeral formatter
     */
    const nb = new Intl.NumberFormat('fr-CA', { style: 'decimal', maximumFractionDigits: 3 })
    const nb2 = new Intl.NumberFormat('fr-CA', {
        style: 'decimal',
        minimumFractionDigits: 0,  // shows no .00 if unnecessary
        maximumFractionDigits: 2,  // rounds at 2 decimals
    });
    const money = new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' })
    const percent = new Intl.NumberFormat('fr-CA', { style: 'percent', maximumFractionDigits: 3 })

    //helper function for salary validations. make sure it's a hourly rate under 1000.00$/hr
    const isValidYear = (): boolean => {
        if (!year) return true;       // empty, null, undefined
        if (year > 2024) return true; // year greater than 2024
        return false;                 // year <= 2024
    };

    const isValidSalary = (values: { value: string }) => {

        // Only validate if year > 2024
        if (!isValidYear()) return true;

        const { value } = values;
        if (!value) return true;

        const sanitized = value.replace(/[^0-9,\.]/g, '');
        const [integer] = sanitized.split(/[.,]/);

        if (integer.length > 3) return false;

        const numericValue = parseFloat(sanitized.replace(',', '.'));
        if (isNaN(numericValue)) return false;

        if (numericValue > 999.99) return false;

        return true;
    };

    useEffect(() => {
    if (officeOptions.length === 1 && !officeId) {
            //console.log(officeOptions[0].value);
            setOfficeId(officeOptions[0].value);
        }
    }, [officeOptions, officeId]);

    const formatDateTime = (raw?: string) => {
        if (!raw) return '';

        let clean = raw.replace(/[^0-9]/g, ''); // remove any non-digit chars

        if (clean.length < 14) return raw; // invalid, just return raw

        let y = clean.substring(0, 4);
        let m = clean.substring(4, 6);
        let d = clean.substring(6, 8);
        let H = clean.substring(8, 10);
        let i = clean.substring(10, 12);
        let s = clean.substring(12, 14);

        return `${y}-${m}-${d} ${H}:${i}:${s}`;
    };

    return (
        <>
            <h2>Saisie de données</h2>
            
            <div className="formWrapper">
                <form action="" className="ratio-form" id="ratioForm">
                    <div className="formNote">
                        <Note>
                            <span>
                                Pour enregistrer les informations entrées ou modifiées, assurez-vous
                                de cliquer sur "Suivant/Enregistrer" avant de quitter, sinon elles seront perdues.
                            </span>
                        </Note>
                    </div>
                    <fieldset key={0} className={getPageClassName(0)}>
                        <legend>Identification</legend>
                        <div>
                            <label htmlFor="etude_id">Étude</label>
                            {
                                data?.selectedRatio ?
                                    <>
                                        <input type="hidden" name="etude_id" readOnly defaultValue={selectedOfficeOption[0].value} />
                                        <input type="text" readOnly defaultValue={selectedOfficeOption[0].label} />
                                    </>
                                    :
                                    
                                    <Select
                                        name="etude_id"
                                        value={officeOptions.find((o: any) => o.value === officeId) || null} // pass full object to select
                                        onChange={(e: any) => setOfficeId(e.value)}
                                        options={officeOptions}
                                    />
                            }
                        </div>

                        <div style={{ marginTop: '20px' }}>

                            <label htmlFor="year">Année de saisie</label>

                            <Select
                                name="year"
                                value={optYears.find((o: any) => o.value === year) || null} // controlled from start
                                onChange={(e: any) => setYear(e.value)}
                                options={optYears}
                            />
                        </div>
                        <div>
                            <p style={{
                                fontSize: 'x-large', margin: '40px 0', fontFamily: 'ITC', lineHeight: 1.2
                            }}>Vous devez compléter le ratio selon votre année financière (12 mois).</p>
                        </div>

                        {/* --- NEW COMPLETE DATE PICKER --- */}
                        <div style={{ marginBottom: '20px' }}>
                            <label htmlFor="complete_date">Date de complétion</label>
                            <input
                                type="date"
                                name="complete_date"
                                value={
                                    formData.complete_date
                                    ? formData.complete_date.substring(0, 10) // first 10 chars = YYYY-MM-DD
                                    : ''
                                }
                                onChange={(e) => {
                                    const dateOnly = e.target.value; // YYYY-MM-DD
                                    const currentTime = new Date();
                                    const hours = currentTime.getHours().toString().padStart(2, '0');
                                    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
                                    const seconds = currentTime.getSeconds().toString().padStart(2, '0');

                                    // append current time
                                    const dateTimeString = `${dateOnly} ${hours}:${minutes}:${seconds}`;
                                    setValue('complete_date', dateTimeString);
                                }}
                            />

                            <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
                                Date de complétion : {formatDateTime(formData.complete_date)} <br />
                                Dernière modification : {formatDateTime(formData.modified_date)}
                                <input type="hidden" name="modified_date" readOnly defaultValue={formatDateTime(formData.modified_date)} />
                            </small>
                        </div>

                        <div>
                            <label htmlFor="user_name"><span className="numPoste">{displayRatios.user_name?.num_row || '100.1'}</span> {displayRatios.user_name?.label || "Nom de la personne responsable de la saisie des données pour l'étude"}</label>
                            <input value={formData.user_name ?? ''} name="user_name" onChange={(e) => { setValue('user_name', e.target.value) }} type="text" required />
                            {!!displayRatios.user_name?.display_desc && (
                                <div className="note">* {displayRatios.user_name?.description}</div>
                            )}
                        </div>
                        <div>
                            <label htmlFor="user_email">
                                <span className="numPoste">{displayRatios.user_email?.num_row || '100.2'}</span>
                                {displayRatios.user_email?.label || 'Courriel de la personne responsable'}
                            </label>
                            <input value={formData.user_email ?? ''} name="user_email" onChange={(e) => { setValue('user_email', e.target.value) }} type="text" required />
                            {!!displayRatios.user_email?.display_desc && (
                                <div className="note">* {displayRatios.user_email?.description}</div>
                            )}
                        </div>
                        <div>
                            <label htmlFor="user_phone">
                                <span className="numPoste">{displayRatios.user_phone?.num_row || '100.3'}</span>
                                {displayRatios.user_phone?.label || 'Téléphone de la personne responsable'}
                            </label>
                            <input value={formData.user_phone ?? ''} name="user_phone" onChange={(e) => { setValue('user_phone', e.target.value) }} type="text" required />
                            {!!displayRatios.user_phone?.display_desc && (
                                <div className="note">* {displayRatios.user_phone?.description}</div>
                            )}
                        </div>
                        <div className="btnrow">
                            <span></span>
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                        
                    </fieldset>

                    <fieldset key={1} className={getPageClassName(1)}>
                        <legend>Statistiques RH</legend>

                        <label htmlFor="nb_notaires_associes"><span className="numPoste">{displayRatios.nb_notaires_associes?.num_row || '101'}</span> {displayRatios.nb_notaires_associes?.label || 'Nombre de notaires associé(e)s'}</label>
                        <NumericFormat name="nb_notaires_associes" value={formData.nb_notaires_associes ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_notaires_associes', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_notaires_associes?.display_desc && (<div className="note">* {displayRatios.nb_notaires_associes?.description}</div>)}

                        <label htmlFor="nb_notaires_salaries"><span className="numPoste">{displayRatios.nb_notaires_salaries?.num_row || '102'}</span> {displayRatios.nb_notaires_salaries?.label || 'Nombre de notaires salarié(e)s '}</label>
                        <NumericFormat name="nb_notaires_salaries" value={formData.nb_notaires_salaries ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_notaires_salaries', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_notaires_salaries?.display_desc && (<div className="note">* {displayRatios.nb_notaires_salaries?.description}</div>)}

                        <label htmlFor="nb_employes"><span className="numPoste">{displayRatios.nb_employes?.num_row || '104'}</span> {displayRatios.nb_employes?.label || 'Nombre de collaborateur(rice)s'}</label>
                        <NumericFormat name="nb_employes" value={formData.nb_employes ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_employes', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_employes?.display_desc && (<div className="note">* {displayRatios.nb_employes?.description}</div>)}

                        <label htmlFor="nb_avocats"><span className="numPoste">{displayRatios.nb_avocats?.num_row || '105'}</span> {displayRatios.nb_avocats?.label || 'Nombre d’avocats(es) et/ou autres juristes'}</label>
                        <NumericFormat name="nb_avocats" value={formData.nb_avocats ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_avocats', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_avocats?.display_desc && (<div className="note">* {displayRatios.nb_avocats?.description}</div>)}

                        <label htmlFor="nb_stagieres"><span className="numPoste">{displayRatios.nb_stagieres?.num_row || '106'}</span> {displayRatios.nb_stagieres?.label || 'Nombre de stagiaire en notariat'}</label>
                        <NumericFormat name="nb_stagieres" value={formData.nb_stagieres ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_stagieres', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_stagieres?.display_desc && (<div className="note">* {displayRatios.nb_stagieres?.description}</div>)}

                        <label htmlFor="nb_saisonniers"><span className="numPoste">{displayRatios.nb_saisonniers?.num_row || '107'}</span> {displayRatios.nb_saisonniers?.label || 'Nombre d’employés saisonniers et/ou étudiants '}</label>
                        <NumericFormat name="nb_saisonniers" value={formData.nb_saisonniers ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_saisonniers', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_saisonniers?.display_desc && (<div className="note">* {displayRatios.nb_saisonniers?.description}</div>)}

                        <label htmlFor="nb_autre"><span className="numPoste">{displayRatios.nb_autre?.num_row || '108'}</span> {displayRatios.nb_autre?.label || 'Nombre de salariés occupant un poste autre que notaire ou collabo. (DG, Adj. Admin, récept., marketing, etc.)'}</label>
                        <NumericFormat name="nb_autre" value={formData.nb_autre ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_autre', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_autre?.display_desc && (<div className="note">* {displayRatios.nb_autre?.description}</div>)}

                        <label htmlFor="nb_employes_temps_plein"><span className="numPoste">{displayRatios.nb_employes_temps_plein?.num_row || '109'}</span> {displayRatios.nb_employes_temps_plein?.label || 'Nombre d’employés à temps plein (32hrs et + par semaine)'}</label>
                        <NumericFormat name="nb_employes_temps_plein" value={formData.nb_employes_temps_plein ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_employes_temps_plein', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_employes_temps_plein?.display_desc && (<div className="note">* {displayRatios.nb_employes_temps_plein?.description}</div>)}

                        <label htmlFor="nb_employes_teletravail"><span className="numPoste">{displayRatios.nb_employes_teletravail?.num_row || '110'}</span> {displayRatios.nb_employes_teletravail?.label || 'Nombre d’employés faisait plus de 60% de leur temps en télétravail'}</label>
                        <NumericFormat name="nb_employes_teletravail" value={formData.nb_employes_teletravail ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_employes_teletravail', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_employes_teletravail?.display_desc && (<div className="note">* {displayRatios.nb_employes_teletravail?.description}</div>)}

                        <label htmlFor="nb_employes_arrive"><span className="numPoste">{displayRatios.nb_employes_arrive?.num_row || '111'}</span> {displayRatios.nb_employes_arrive?.label || 'Nombre de nouveaux employés dans les derniers 12 mois'}</label>
                        <NumericFormat name="nb_employes_arrive" value={formData.nb_employes_arrive ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_employes_arrive', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_employes_arrive?.display_desc && (<div className="note">* {displayRatios.nb_employes_arrive?.description}</div>)}

                        <label htmlFor="nb_employes_depart"><span className="numPoste">{displayRatios.nb_employes_depart?.num_row || '112'}</span> {displayRatios.nb_employes_depart?.label || 'Nombre d’employés toute catégorie confondue ayant quitté l’entreprise dans les derniers 12 mois'}</label>
                        <NumericFormat name="nb_employes_depart" value={formData.nb_employes_depart ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_employes_depart', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_employes_depart?.display_desc && (<div className="note">* {displayRatios.nb_employes_depart?.description}</div>)}

                        <label htmlFor="nb_succursales"><span className="numPoste">{displayRatios.nb_succursales?.num_row || '113'}</span> {displayRatios.nb_succursales?.label || 'Nombre de succursales (incluant le siège social)'}</label>
                        <NumericFormat name="nb_succursales" value={formData.nb_succursales ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_succursales', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} required />
                        {!!displayRatios.nb_succursales?.display_desc && (<div className="note">* {displayRatios.nb_succursales?.description}</div>)}

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    <fieldset key={2} className={getPageClassName(2)}>
                        <legend>Profil financier</legend>

                        <div>
                            <label htmlFor="nb_dossiers"><span className="numPoste">{displayRatios.nb_dossiers?.num_row || '201'}</span> {displayRatios.nb_dossiers?.label || 'Nombre de dossiers ouverts par l’étude'}</label>
                            <NumericFormat name="nb_dossiers" value={formData.nb_dossiers ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_dossiers', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} />
                            {!!displayRatios.nb_dossiers?.display_desc && (
                                <div className="note">* {displayRatios.nb_dossiers?.description || 'Excluant les dossiers de Services PME - Service de base'}</div>
                            )}
                        </div>

                        <label htmlFor="nb_minutes"><span className="numPoste">{displayRatios.nb_minutes?.num_row || '202'}</span> {displayRatios.nb_minutes?.label || 'Nombre de minutes signées par les notaires'}</label>
                        <NumericFormat name="nb_minutes" value={formData.nb_minutes ?? 0} onValueChange={(values: { value: string }) => { setValue('nb_minutes', values.value) }} decimalScale={2} decimalSeparator="," thousandSeparator=" " allowNegative={false} />
                        {!!displayRatios.nb_minutes?.display_desc && (
                            <div className="note">* {displayRatios.nb_minutes?.description}</div>
                        )}

                        <div className='legacy_field'>
                            {/* Toggle Header */}
                            <div className='toggle' onClick={() => setIsHonorairesLegacyVisible(!isHonorairesLegacyVisible)} style={{ cursor: 'pointer' }}>
                                203 (ancien champ) {isHonorairesLegacyVisible ? '-' : '+'}
                            </div>
                            
                            {/* Collapsible Content */}
                            <div className={`fieldLegacy ${isHonorairesLegacyVisible ? '' : 'colapsed'}`}>
                                <label htmlFor="honoraires">
                                    <span className="numPoste">{displayRatios.honoraires?.num_row || '203'}</span> 
                                    {displayRatios.honoraires?.label || 'Honoraires'}
                                </label>
                                <NumericFormat
                                    name="honoraires"
                                    value={formData.honoraires ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('honoraires', values.value); }}
                                    decimalScale={2} 
                                    fixedDecimalScale 
                                    decimalSeparator="," 
                                    thousandSeparator=" " 
                                    suffix=" $" 
                                />
                                {!!displayRatios.honoraires?.display_desc && (
                                    <div className="note">* {displayRatios.honoraires?.description || 'Honoraires facturés aux clients.'}</div>
                                )}
                            </div>
                        </div>

                        {/** 
                         *  new fields 203.1 203.2 and 203.3
                        */}
                        <legend>203 Chiffre d’affaires avant taxes</legend>
                        <div>
                            <label htmlFor="honoraires_prof_av_taxes"><span className="numPoste">{displayRatios.honoraires_prof_av_taxes?.num_row || '203.1'}</span> {displayRatios.honoraires_prof_av_taxes?.label || 'Honoraires professionnels avant taxes'}</label>
                            <NumericFormat
                                name="honoraires_prof_av_taxes"
                                value={formData.honoraires_prof_av_taxes ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('honoraires_prof_av_taxes', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.honoraires_prof_av_taxes?.display_desc && (
                                <div className="note">* {displayRatios.honoraires_prof_av_taxes?.description || 'Honoraires professionnels avant taxes'}</div>
                            )}
                        </div>

                        <div>
                            <label htmlFor="debourses_taxables"><span className="numPoste">{displayRatios.debourses_taxables?.num_row || '203.2'}</span> {displayRatios.debourses_taxables?.label || 'Déboursés taxables'}</label>
                            <NumericFormat
                                name="debourses_taxables"
                                value={formData.debourses_taxables ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('debourses_taxables', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.debourses_taxables?.display_desc && (
                                <div className="note">* {displayRatios.debourses_taxables?.description || 'Déboursés taxables'}</div>
                            )}
                        </div>

                        <div>
                            <label htmlFor="debourses_non_taxables"><span className="numPoste">{displayRatios.debourses_non_taxables?.num_row || '203.3'}</span> {displayRatios.debourses_non_taxables?.label || 'Déboursés non taxables'}</label>
                            <NumericFormat
                                name="debourses_non_taxables"
                                value={formData.debourses_non_taxables ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('debourses_non_taxables', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.debourses_non_taxables?.display_desc && (
                                <div className="note">* {displayRatios.debourses_non_taxables?.description || 'Déboursés non taxables'}</div>
                            )}
                        </div>


                        
                        {/** 
                         * Chiffre d'affaires avant taxes would be auto calculated from 203.1 203.2 and 203.3 and read only
                        */}
                        <div>
                            <label htmlFor="chiffre_affaires_av_taxes">
                                <span className="numPoste">&nbsp;</span> 
                                {displayRatios.chiffre_affaires_av_taxes?.label || "Total du chiffre d’affaires avant taxes"}
                            </label>
                            <NumericFormat
                                readOnly
                                name="chiffre_affaires_av_taxes"
                                // Use the state variable updated by your useEffect
                                value={chiffreAffairesAvTaxesTotal} 
                                decimalScale={2} 
                                fixedDecimalScale 
                                decimalSeparator="," 
                                thousandSeparator=" " 
                                suffix=" $" 
                            />
                            {!!displayRatios.chiffre_affaires_av_taxes?.display_desc && (
                                <div className="note">* {displayRatios.chiffre_affaires_av_taxes?.description || 'Chiffre d’affaires avant taxes'}</div>
                            )}
                        </div>

                        {/**
                         * keep for the current facturation moment here. To be removed or modified.
                         * we will determine at a later time that how we will handle legacy data
                         */}
                        <div className='legacy_field'>
                            <div className='toggle' onClick={() => setIsFacturationLegacyVisible(!isFacturationLegacyVisible)} style={{ cursor: 'pointer' }}>
                                204 (ancien champ) {isFacturationLegacyVisible ? '-' : '+'}
                            </div>
                            
                            <div className={`fieldLegacy ${isFacturationLegacyVisible ? '' : 'colapsed'}`}>
                                <label htmlFor="facturation">
                                    <span className="numPoste">{displayRatios.facturation?.num_row || '204'}</span> {displayRatios.facturation?.label || 'Facturation'}
                                </label>
                                <NumericFormat
                                    name="facturation"
                                    value={formData.facturation ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('facturation', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                                {!!displayRatios.facturation?.display_desc && (
                                    <div className="note">* {displayRatios.facturation?.description || 'Honoraires + Débours + Taxes'}</div>
                                )}
                            </div>
                        </div>

                        {/** 
                         * todo: Facturation (204)
                         * 204 = ((203.1 + 203.2) × 1,14975) + 203.3
                        */}
                        <div>
                            <label htmlFor="facturation_total">
                                <span className="numPoste">{displayRatios.facturation_total?.num_row || '204'}</span> 
                                {displayRatios.facturation_total?.label || 'Facturation'}
                            </label>
                            <NumericFormat
                                readOnly
                                name="facturation_total"
                                value={((Number(formData.honoraires_prof_av_taxes) || 0) + (Number(formData.debourses_taxables) || 0)) * 1.14975 + (Number(formData.debourses_non_taxables) || 0)}
                                decimalScale={2} 
                                fixedDecimalScale 
                                decimalSeparator="," 
                                thousandSeparator=" " 
                                suffix=" $" 
                            />
                            {displayRatios.facturation_total?.display_desc !== undefined && (
                                <div className="note">
                                    * {Number(displayRatios.facturation_total.display_desc) === 0 
                                        ? '((203.1 + 203.2) × 1,14975) + 203.3' 
                                        : (displayRatios.facturation_total.description || '((203.1 + 203.2) × 1,14975) + 203.3')
                                    }
                                </div>
                            )}
                        </div>

                      
                        {/* // vieux commented out for the moment  
                        <div>
                            <label htmlFor="chiffre_affaires"><span className="numPoste">{displayRatios.chiffre_affaires?.num_row || '205'}</span> {displayRatios.chiffre_affaires?.label || 'Chiffre d’affaires'}</label>
                            <NumericFormat
                                name="chiffre_affaires"
                                value={formData.chiffre_affaires ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('chiffre_affaires', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.chiffre_affaires?.display_desc && (
                                <div className="note">* {displayRatios.chiffre_affaires?.description || 'Honoraires + Débours + Autres revenus reliés à la pratique notariale (mais excluant les taxes). Exemple : intérêts sur compte en souffrance. Les revenus de location d\'immeubles ne font pas partie des revenus liées à la pratique notariale (ils doivent donc être exclus)'}</div>
                            )}
                        </div>
                        */}
                        {/* New Read-Only Field 205 linked to 203 */}

                        <div className='legacy_field'>
                            {/* Toggle trigger: Shows the num_row and a label to indicate it's an old field */}
                            <div 
                                className='toggle' 
                                onClick={() => setIsLegacyVisible(!isLegacyVisible)} 
                                style={{ cursor: 'pointer' }}
                            >
                                {displayRatios.chiffre_affaires?.num_row || '205'} (ancien champ) {isLegacyVisible ? '-' : '+'}
                            </div>
                            
                            {/* Content: Hidden when collapsed via CSS class */}
                            <div className={`fieldLegacy ${isLegacyVisible ? '' : 'colapsed'}`}>
                                <div>
                                    <label htmlFor="chiffre_affaires">
                                        <span className="numPoste">
                                            {displayRatios.chiffre_affaires?.num_row || '205'}
                                        </span> 
                                        {displayRatios.chiffre_affaires?.label || 'Chiffre d’affaires'}
                                    </label>
                                    <NumericFormat
                                        readOnly
                                        name="chiffre_affaires"
                                        value={formData.chiffre_affaires ?? 0}
                                        decimalScale={2} 
                                        fixedDecimalScale 
                                        decimalSeparator="," 
                                        thousandSeparator=" " 
                                        suffix=" $" 
                                    />
                                    {!!displayRatios.chiffre_affaires?.display_desc && (
                                        <div className="note">
                                            * {displayRatios.chiffre_affaires?.description || 'Honoraires + Débours + Autres revenus reliés à la pratique notariale (mais excluant les taxes).'}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="totalExpenses"><span className="numPoste">{displayRatios.totalExpenses?.num_row || '206'}</span> {displayRatios.totalExpenses?.label || 'Total des dépenses'}</label>
                            <NumericFormat
                                name="totalExpenses"
                                value={formData.totalExpenses ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('totalExpenses', values.value) }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.totalExpenses?.display_desc && (
                                <div className="note">* {displayRatios.totalExpenses?.description || 'Total de toutes les dépenses, incluant les salaires.'}</div>
                            )}
                        </div>

                        <div className='legacy_field'>
                            {/* On ajoute l'onClick pour basculer l'état et on change le signe dynamiquement */}
                            <div className='toggle' onClick={() => setIsLegacyVisible(!isLegacyVisible)} style={{ cursor: 'pointer' }}>
                                207 (ancien champ) {isLegacyVisible ? '-' : '+'}
                            </div>
                            
                            {/* On applique la classe 'colapsed' uniquement si isLegacyVisible est faux */}
                            <div className={`fieldLegacy ${isLegacyVisible ? '' : 'colapsed'}`}>
                                <label htmlFor="benefices_nets">
                                    <span className="numPoste">{displayRatios.benefices_nets?.num_row || '207'}</span> 
                                    {displayRatios.benefices_nets?.label || 'Bénéfice net'}
                                </label>
                                <NumericFormat
                                    name="benefices_nets"
                                    value={formData.benefices_nets ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('benefices_nets', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                                
                                {!!displayRatios.benefices_nets?.display_desc && (
                                    <div className="note">* {displayRatios.benefices_nets?.description || 'Chiffre aux états Financiers moins les prélèvements des associé(e)s ou les dividendes aux actionnaires, le cas échéant. Au besoin, à des fins de comparaison, les prélèvements représentent le revenu moyen des associés et/ou actionnaires, lequel s’élève à 119 810 $ selon la dernière enquête de la CNQ'}</div>
                                )}
                            </div>
                        </div>
                        
                        <legend>207 Bénéfices nets / Dividendes aux actionnaires</legend>

                        {/* 207.2: Prélèvements des associés / dividendes aux actionnaires */}
                        <div>
                            <label htmlFor="prelev_asso_divi_actionnaires">
                                <span className="numPoste">{displayRatios.prelev_asso_divi_actionnaires?.num_row || '207.1'}</span> 
                                {displayRatios.prelev_asso_divi_actionnaires?.label || 'Prélèvements des associés / dividendes aux actionnaires'}
                            </label>
                            <NumericFormat
                                name="prelev_asso_divi_actionnaires"
                                value={formData.prelev_asso_divi_actionnaires ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('prelev_asso_divi_actionnaires', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.prelev_asso_divi_actionnaires?.display_desc && (
                                <div className="note">* {displayRatios.prelev_asso_divi_actionnaires?.description || ''}</div>
                            )}
                        </div>

                        {/* 207.2: Bénéfices nets avant prélèvements */}
                        <div>
                            <label htmlFor="beneficesNets_av_prelevements_dividendes_total">
                                <span className="numPoste">{displayRatios.beneficesNets_av_prelevements_dividendes_total?.num_row || '207.2'}</span> 
                                {displayRatios.beneficesNets_av_prelevements_dividendes_total?.label || 'Bénéfices nets avant prélèvements'}
                            </label>
                            <NumericFormat
                                readOnly
                                name="beneficesNets_av_prelevements_dividendes_total"
                                // We calculate the CA on the fly here using the individual inputs
                                value={
                                    ([
                                        formData.honoraires_prof_av_taxes, 
                                        formData.debourses_taxables, 
                                        formData.debourses_non_taxables
                                    ].reduce((sum, a) => sum + (Number(a) || 0), 0)) 
                                    - (Number(formData.totalExpenses) || 0) 
                                    - (Number(formData.prelev_asso_divi_actionnaires) || 0)
                                }
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" 
                            />
                            {!!displayRatios.beneficesNets_av_prelevements_dividendes_total?.display_desc && (
                                <div className="note">* {displayRatios.beneficesNets_av_prelevements_dividendes_total?.description || '203 - 206 - 207.1'}</div>
                            )}
                        </div>

                        {/** 
                         * 207: Total bénéfices nets
                        */}

                        <div>
                            <label htmlFor="benefices_nets_total">
                                <span className="numPoste">&nbsp;</span> 
                                {displayRatios.benefices_nets_total?.label || 'Total bénéfices nets'}
                            </label>
                            <NumericFormat
                                readOnly
                                name="benefices_nets_total"
                                // We calculate (207.2 + 207.1)
                                value={
                                    (([
                                        formData.honoraires_prof_av_taxes, 
                                        formData.debourses_taxables, 
                                        formData.debourses_non_taxables
                                    ].reduce((sum, a) => sum + (Number(a) || 0), 0)) 
                                    - (Number(formData.totalExpenses) || 0)) // This simplifies to (CA - 206)
                                }
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" 
                            />
                            {!!displayRatios.benefices_nets_total?.display_desc && (
                                <div className="note">* {displayRatios.benefices_nets_total?.description || '207.1 + 207.2'}</div>
                            )}
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>


                    <fieldset key={3} className={getPageClassName(3, true)}>
                        <legend>301 Masse salariale</legend>
                        <div className="row">
                            <label htmlFor="salaire_notaires_associes"><span className="numPoste">{displayRatios.salaire_notaires_associes?.num_row || '301.1'}</span> {displayRatios.salaire_notaires_associes?.label || 'Salaires des notaires associé(e)s'}</label>
                            <NumericFormat
                                name="salaire_notaires_associes"
                                value={formData.salaire_notaires_associes ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_notaires_associes', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_notaires_associes?.display_desc && (
                                <div className="note">* {displayRatios.salaire_notaires_associes?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_notaires_salaries"><span className="numPoste">{displayRatios.salaire_notaires_salaries?.num_row || '301.2'}</span> {displayRatios.salaire_notaires_salaries?.label || 'Salaires des notaires salarié(e)s'}</label>
                            <NumericFormat
                                name="salaire_notaires_salaries"
                                value={formData.salaire_notaires_salaries ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_notaires_salaries', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_notaires_salaries?.display_desc && (
                                <div className="note">* {displayRatios.salaire_notaires_salaries?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_coll"><span className="numPoste">{displayRatios.salaire_coll?.num_row || '301.3'}</span> {displayRatios.salaire_coll?.label || 'Salaires des collaborateur(rice)s'}</label>
                            <NumericFormat
                                name="salaire_coll"
                                value={formData.salaire_coll ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_coll', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_coll?.display_desc && (
                                <div className="note">* {displayRatios.salaire_coll?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_avocats"><span className="numPoste">{displayRatios.salaire_avocats?.num_row || '301.4'}</span> {displayRatios.salaire_avocats?.label || 'Salaires des avocats(es) et/ou autres juristes'}</label>
                            <NumericFormat
                                name="salaire_avocats"
                                value={formData.salaire_avocats ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_avocats', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_avocats?.display_desc && (
                                <div className="note">* {displayRatios.salaire_avocats?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_stagiaires"><span className="numPoste">{displayRatios.salaire_stagiaires?.num_row || '301.5'}</span> {displayRatios.salaire_stagiaires?.label || 'Salaires des stagiaires en notariat'}</label>
                            <NumericFormat
                                name="salaire_stagiaires"
                                value={formData.salaire_stagiaires ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_stagiaires', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_stagiaires?.display_desc && (
                                <div className="note">* {displayRatios.salaire_stagiaires?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_saisonniers"><span className="numPoste">{displayRatios.salaire_saisonniers?.num_row || '301.6'}</span> {displayRatios.salaire_saisonniers?.label || 'Salaires d’employés saisonniers'}</label>
                            <NumericFormat
                                name="salaire_saisonniers"
                                value={formData.salaire_saisonniers ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_saisonniers', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_saisonniers?.display_desc && (
                                <div className="note">* {displayRatios.salaire_saisonniers?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaire_autres"><span className="numPoste">{displayRatios.salaire_autres?.num_row || '301.7'}</span> {displayRatios.salaire_autres?.label || 'Salaires des salariés occupant un poste autre que notaire ou collabo. (DG, Adj. Admin, récept., marketing, etc.)'}</label>
                            <NumericFormat
                                name="salaire_autres"
                                value={formData.salaire_autres ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_autres', values.value, 'salary'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaire_autres?.display_desc && (
                                <div className="note">* {displayRatios.salaire_autres?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_charges_sociales"><span className="numPoste">{displayRatios.depense_charges_sociales?.num_row || '301.8'}</span> {displayRatios.depense_charges_sociales?.label || 'Charges sociales et avantages'}</label>
                            <NumericFormat
                                name="depense_charges_sociales"
                                value={formData.depense_charges_sociales ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_charges_sociales', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_charges_sociales?.display_desc && (
                                <div className="note">* {displayRatios.depense_charges_sociales?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="salaires"><span className="numPoste">{displayRatios.salaires?.num_row || '301'}</span> {displayRatios.salaires?.label || 'Total des salaires'}<sup>*</sup></label>
                            <NumericFormat
                                readOnly
                                name="salaires"
                                value={[ formData.salaire_notaires_associes,formData.salaire_notaires_salaries, formData.salaire_coll, formData.salaire_avocats, formData.salaire_stagiaires, formData.salaire_saisonniers, formData.salaire_autres, formData.depense_charges_sociales].reduce((partialSum, a) => partialSum + (a || 0), 0)}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.salaires?.display_desc && (
                                <div className="note">* {displayRatios.salaires?.description || 'Excluant le prélèvement des associé(e)s.'}</div>
                            )}
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>


                    <fieldset key={4} className={getPageClassName(4, true)}>
                        <legend>Frais d’exploitation</legend>
                        <div className="row">
                            <label htmlFor="depense_loyer"><span className="numPoste">{displayRatios.depense_loyer?.num_row || '302'}</span> {displayRatios.depense_loyer?.label || 'Loyer'}<sup>*</sup></label>
                            <NumericFormat
                                name="depense_loyer"
                                value={formData.depense_loyer ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_loyer', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_loyer?.display_desc && (
                                <div className="note">* {displayRatios.depense_loyer?.description || 'Locataire: le loyer versé au propriétaire et tout frais afférent (chauffage, entretien, etc.). Propriétaire: les frais d’intérêts et tout frais afférent (chauffage, entretien, etc.).'}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_amortissement"><span className="numPoste">{displayRatios.depense_amortissement?.num_row || '303'}</span> {displayRatios.depense_amortissement?.label || 'Amortissement'}</label>
                            <NumericFormat
                                name="depense_amortissement"
                                value={formData.depense_amortissement ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_amortissement', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_amortissement?.display_desc && (
                                <div className="note">* {displayRatios.depense_amortissement?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_debourses_dossiers"><span className="numPoste">{displayRatios.depense_debourses_dossiers?.num_row || '304'}</span> {displayRatios.depense_debourses_dossiers?.label || 'Débours de dossiers'}</label>
                            <NumericFormat
                                name="depense_debourses_dossiers"
                                value={formData.depense_debourses_dossiers ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_debourses_dossiers', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_debourses_dossiers?.display_desc && (
                                <div className="note">* {displayRatios.depense_debourses_dossiers?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_inters_prets_marge"><span className="numPoste">{displayRatios.depense_inters_prets_marge?.num_row || '305'}</span> {displayRatios.depense_inters_prets_marge?.label || 'Intérêts sur prêts et marge(s)'}</label>
                            <NumericFormat
                                name="depense_inters_prets_marge"
                                value={formData.depense_inters_prets_marge ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_inters_prets_marge', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_inters_prets_marge?.display_desc && (
                                <div className="note">* {displayRatios.depense_inters_prets_marge?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_assurance_bureau_cyberassurance"><span className="numPoste">{displayRatios.depense_assurance_bureau_cyberassurance?.num_row || '306'}</span> {displayRatios.depense_assurance_bureau_cyberassurance?.label || 'Assurance bureau et cyberassurance'}</label>
                            <NumericFormat
                                name="depense_assurance_bureau_cyberassurance"
                                value={formData.depense_assurance_bureau_cyberassurance ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_assurance_bureau_cyberassurance', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_assurance_bureau_cyberassurance?.display_desc && (
                                <div className="note">* {displayRatios.depense_assurance_bureau_cyberassurance?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_telecom"><span className="numPoste">{displayRatios.depense_telecom?.num_row || '307'}</span> {displayRatios.depense_telecom?.label || 'Télécommunications'}</label>
                            <NumericFormat
                                name="depense_telecom"
                                value={formData.depense_telecom ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_telecom', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_telecom?.display_desc && (
                                <div className="note">* {displayRatios.depense_telecom?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_fournitures_de_bureau"><span className="numPoste">{displayRatios.depense_fournitures_de_bureau?.num_row || '308'}</span> {displayRatios.depense_fournitures_de_bureau?.label || 'Messagerie/papeterie'}</label>
                            <NumericFormat
                                name="depense_fournitures_de_bureau"
                                value={formData.depense_fournitures_de_bureau ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_fournitures_de_bureau', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_fournitures_de_bureau?.display_desc && (
                                <div className="note">* {displayRatios.depense_fournitures_de_bureau?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_equip_informatique"><span className="numPoste">{displayRatios.depense_equip_informatique?.num_row || '309'}</span> {displayRatios.depense_equip_informatique?.label || 'Équipement et soutien informatique'}</label>
                            <NumericFormat
                                name="depense_equip_informatique"
                                value={formData.depense_equip_informatique ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_equip_informatique', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_equip_informatique?.display_desc && (
                                <div className="note">* {displayRatios.depense_equip_informatique?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="depense_frais_pmeinter"><span className="numPoste">{displayRatios.depense_frais_pmeinter?.num_row || '310'}</span> {displayRatios.depense_frais_pmeinter?.label || 'Frais d’utilisation du robot PME INTER Notaires'}</label>
                            <NumericFormat
                                name="depense_frais_pmeinter"
                                value={formData.depense_frais_pmeinter ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_frais_pmeinter', values.value, 'depenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_frais_pmeinter?.display_desc && (
                                <div className="note">* {displayRatios.depense_frais_pmeinter?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="regularExpenses"><span className="numPoste">{displayRatios.regularExpenses?.num_row || ''}</span> {displayRatios.regularExpenses?.label || 'Somme des frais d’exploitation'}</label>
                            <NumericFormat
                                readOnly
                                name="regularExpenses"
                                value={regularExpenses ?? 0}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.regularExpenses?.display_desc && (
                                <div className="note">* {displayRatios.regularExpenses?.description}</div>
                            )}
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    <fieldset key={5} className={getPageClassName(5, true)}>
                        <legend>Dépenses Diverses</legend>
                        <div className="row">
                            <label htmlFor="depense_firme_comptable"><span className="numPoste">{displayRatios.depense_firme_comptable?.num_row || '311'}</span> {displayRatios.depense_firme_comptable?.label || 'Firme comptable'}</label>
                            <NumericFormat
                                name="depense_firme_comptable"
                                value={formData.depense_firme_comptable ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_firme_comptable', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_firme_comptable?.display_desc && (
                                <div className="note">* {displayRatios.depense_firme_comptable?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="depense_publicite"><span className="numPoste">{displayRatios.depense_publicite?.num_row || '312'}</span> {displayRatios.depense_publicite?.label || 'Publicité: représentation, évènement, web et réseaux sociaux'}</label>
                            <NumericFormat
                                name="depense_publicite"
                                value={formData.depense_publicite ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_publicite', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_publicite?.display_desc && (
                                <div className="note">* {displayRatios.depense_publicite?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="depense_assurance_responsabilite"><span className="numPoste">{displayRatios.depense_assurance_responsabilite?.num_row || '313'}</span> {displayRatios.depense_assurance_responsabilite?.label || 'Assurance responsabilité'}</label>
                            <NumericFormat
                                name="depense_assurance_responsabilite"
                                value={formData.depense_assurance_responsabilite ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_assurance_responsabilite', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_assurance_responsabilite?.display_desc && (
                                <div className="note">* {displayRatios.depense_assurance_responsabilite?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="depense_cotisation_professionnelle"><span className="numPoste">{displayRatios.depense_cotisation_professionnelle?.num_row || '314'}</span> {displayRatios.depense_cotisation_professionnelle?.label || 'Cotisation professionnelle'}</label>
                            <NumericFormat
                                name="depense_cotisation_professionnelle"
                                value={formData.depense_cotisation_professionnelle ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_cotisation_professionnelle', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_cotisation_professionnelle?.display_desc && (
                                <div className="note">* {displayRatios.depense_cotisation_professionnelle?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="depense_formation"><span className="numPoste">{displayRatios.depense_formation?.num_row || '315'}</span> {displayRatios.depense_formation?.label || 'Formations du personnel'}<sup>*</sup></label>
                            <NumericFormat
                                name="depense_formation"
                                value={formData.depense_formation ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_formation', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_formation?.display_desc && (
                                <div className="note">* {displayRatios.depense_formation?.description || 'Inclure les frais du congrès PME INTER Notaires'}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="depense_mauvaises_creances"><span className="numPoste">{displayRatios.depense_mauvaises_creances?.num_row || '316'}</span> {displayRatios.depense_mauvaises_creances?.label || 'Mauvaises créances'}</label>
                            <NumericFormat
                                name="depense_mauvaises_creances"
                                value={formData.depense_mauvaises_creances ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('depense_mauvaises_creances', values.value, 'autreDepenses'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.depense_mauvaises_creances?.display_desc && (
                                <div className="note">* {displayRatios.depense_mauvaises_creances?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="totalOtherExpenses"><span className="numPoste">{displayRatios.totalOtherExpenses?.num_row || ''}</span> {displayRatios.totalDiverseExpenses?.label || 'Somme des dépenses diverses'}</label>
                            <NumericFormat
                                readOnly
                                name="totalOtherExpenses"
                                value={totalDiverseExpenses ?? 0}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.totalOtherExpenses?.display_desc && (
                                <div className="note">* {displayRatios.totalOtherExpenses?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="otherExpenses"><span className="numPoste">{displayRatios.otherExpenses?.num_row || '317'}</span> {displayRatios.otherExpenses?.label || 'Autres dépenses'}</label>
                            <NumericFormat
                                name="otherExpenses"
                                value={formData.otherExpenses ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => {
                                    setValue('otherExpenses', values.value, 'autreDepenses');
                                }}
                                decimalScale={2}
                                fixedDecimalScale
                                decimalSeparator=","
                                thousandSeparator=" "
                                suffix=" $" />
                            {!!displayRatios.otherExpenses?.display_desc && (
                                <div className="note">* {displayRatios.otherExpenses?.description || 'Inscrivez le montant manquant afin que la somme des dépenses totales (318) corresponde à celle de vos états financiers.'}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="balanceExpenses"><span className="numPoste">{displayRatios.balanceExpenses?.num_row || '318'}</span> {displayRatios.balanceExpenses?.label || 'Somme des dépenses totales'}</label>
                            <NumericFormat
                                readOnly
                                name="balanceExpenses"
                                value={balanceExpenses ?? 0}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.balanceExpenses?.display_desc && (
                                <div className="note">* {displayRatios.balanceExpenses?.description}</div>
                            )}
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    
                    <fieldset key={6} className={getPageClassName(6, true)}>
                        <legend>400 Renseigments - États financiers</legend>
                        <div className="row">
                            <label htmlFor="recevables"><span className="numPoste">{displayRatios.recevables?.num_row || '401'}</span> {displayRatios.recevables?.label || 'Recevables à la fin de la période'}</label>
                            <NumericFormat
                                name="recevables"
                                value={formData.recevables ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('recevables', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.recevables?.display_desc && (
                                <div className="note">* {displayRatios.recevables?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="travaux_en_cours"><span className="numPoste">{displayRatios.travaux_en_cours?.num_row || '402'}</span> {displayRatios.travaux_en_cours?.label || 'Travaux en cours à la fin de la période (TEC)'}</label>
                            <NumericFormat
                                name="travaux_en_cours"
                                value={formData.travaux_en_cours ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('travaux_en_cours', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.travaux_en_cours?.display_desc && (
                                <div className="note">* {displayRatios.travaux_en_cours?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="total_actifs"><span className="numPoste">{displayRatios.total_actifs?.num_row || '403'}</span> {displayRatios.total_actifs?.label || 'Total des actifs à court terme - fin de période'}</label>
                            <NumericFormat
                                name="total_actifs"
                                value={formData.total_actifs ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('total_actifs', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.total_actifs?.display_desc && (
                                <div className="note">* {displayRatios.total_actifs?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="total_passifs"><span className="numPoste">{displayRatios.total_passifs?.num_row || '404'}</span> {displayRatios.total_passifs?.label || 'Total des passifs à court terme - fin de période'}</label>
                            <NumericFormat
                                name="total_passifs"
                                value={formData.total_passifs ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('total_passifs', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.total_passifs?.display_desc && (
                                <div className="note">* {displayRatios.total_passifs?.description}</div>
                            )}
                        </div>
                        <div className="row">
                            <label htmlFor="capital_associes"><span className="numPoste">{displayRatios.capital_associes?.num_row || '405'}</span> {displayRatios.capital_associes?.label || 'Capitaux propres ou avoir des associés'}</label>
                            <NumericFormat
                                name="capital_associes"
                                value={formData.capital_associes ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('capital_associes', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.capital_associes?.display_desc && (
                                <div className="note">* {displayRatios.capital_associes?.description}</div>
                            )}
                        </div>
                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    <fieldset key={7} className={getPageClassName(7, true)}>
                        <legend>501 Immobilier</legend>

                        <div className="row">
                            <label htmlFor="immobilier_existant"><span className="numPoste">{displayRatios.immobilier_residentiel?.num_row || '501.1'}</span> {displayRatios.immobilier_residentiel?.label || 'Immobilier résidentiel'}</label>
                            <NumericFormat
                                name="immobilier_residentiel"
                                value={formData.immobilier_residentiel ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('immobilier_residentiel', values.value, 'immobilier') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.immobilier_residentiel?.display_desc && (
                                <div className="note">* {displayRatios.immobilier_residentiel?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="immobilier_comm_ind"><span className="numPoste">{displayRatios.immobilier_comm_ind?.num_row || '501.2'}</span> {displayRatios.immobilier_comm_ind?.label || 'Immobilier commercial & industriel'}</label>
                            <NumericFormat
                                name="immobilier_comm_ind"
                                value={formData.immobilier_comm_ind ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('immobilier_comm_ind', values.value, 'immobilier') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.immobilier_comm_ind?.display_desc && (
                                <div className="note">* {displayRatios.immobilier_comm_ind?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="immobilier_autre"><span className="numPoste">{displayRatios.immobilier_autre?.num_row || '501.3'}</span> {displayRatios.immobilier_autre?.label || 'Autres'}</label>
                            <NumericFormat
                                name="immobilier_autre"
                                value={formData.immobilier_autre ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('immobilier_autre', values.value, 'immobilier') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.immobilier_autre?.display_desc && (
                                <div className="note">* {displayRatios.immobilier_autre?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="immobilier_total"><span className="numPoste">{displayRatios.immobilier_total?.num_row || '501'}</span> {displayRatios.immobilier_total?.label || 'Total'}</label>
                            <NumericFormat
                                readOnly
                                name="immobilier_total"
                                value={[formData.immobilier_residentiel, formData.immobilier_comm_ind, formData.immobilier_autre].reduce((partialSum, a) => partialSum + (a || 0), 0)}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.immobilier_total?.display_desc && (
                                <div className="note">* {displayRatios.immobilier_total?.description}</div>
                            )}
                        </div>
                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    <fieldset key={8} className={getPageClassName(8, true)}>
                        <legend>502 Droit des affaires</legend>

                        <div className="row">
                            <label htmlFor="service_corporatif"><span className="numPoste">{displayRatios.service_corporatif?.num_row || '502.1'}</span> {displayRatios.service_corporatif?.label || 'Service Corporatif / forfait entrepreneur:'}</label>
                            <NumericFormat
                                name="service_corporatif"
                                value={formData.service_corporatif ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('service_corporatif', values.value, 'business'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.service_corporatif?.display_desc && (
                                <div className="note">* {displayRatios.service_corporatif?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="corporatif"><span className="numPoste">{displayRatios.corporatif?.num_row || '502.2'}</span> {displayRatios.corporatif?.label || 'Droit corporatif'}</label>
                            <NumericFormat
                                name="corporatif"
                                value={formData.corporatif ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('corporatif', values.value, 'business') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.corporatif?.display_desc && (
                                <div className="note">* {displayRatios.corporatif?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="corporatif_autre"><span className="numPoste">{displayRatios.corporatif_autre?.num_row || '502.3'}</span> {displayRatios.corporatif_autre?.label || 'Autres'}</label>
                            <NumericFormat
                                name="corporatif_autre"
                                value={formData.corporatif_autre ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('corporatif_autre', values.value, 'business') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.corporatif_autre?.display_desc && (
                                <div className="note">* {displayRatios.corporatif_autre?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="commercial_corporatif"><span className="numPoste">{displayRatios.commercial_corporatif?.num_row || '502'}</span> {displayRatios.commercial_corporatif?.label || 'Total'}</label>
                            <NumericFormat
                                readOnly
                                name="commercial_corporatif"
                                value={[formData.service_corporatif, formData.corporatif, formData.corporatif_autre].reduce((partialSum, a) => partialSum + (a || 0), 0)}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.commercial_corporatif?.display_desc && (
                                <div className="note">* {displayRatios.commercial_corporatif?.description}</div>
                            )}
                        </div>
                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset> 


                    <fieldset key={9} className={getPageClassName(9, true)}>
                        <legend>503 Droit de la personne</legend>

                        <div className="row">
                            <label htmlFor="testaments_mandats"><span className="numPoste">{displayRatios.testaments_mandats?.num_row || '503.1'}</span> {displayRatios.testaments_mandats?.label || 'Testaments, mandats et DMA'}</label>
                            <NumericFormat
                                name="testaments_mandats"
                                value={formData.testaments_mandats ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('testaments_mandats', values.value, 'indiv') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.testaments_mandats?.display_desc && (
                                <div className="note">* {displayRatios.testaments_mandats?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="successions"><span className="numPoste">{displayRatios.successions?.num_row || '503.2'}</span> {displayRatios.successions?.label || 'Droit de la personne (succession et famille excluant 503.1)'}</label>
                            <NumericFormat
                                name="successions"
                                value={formData.successions ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('successions', values.value, 'indiv') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.successions?.display_desc && (
                                <div className="note">* {displayRatios.successions?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="autres_personne_familial"><span className="numPoste">{displayRatios.autres_personne_familial?.num_row || '503.3'}</span> {displayRatios.autres_personne_familial?.label || 'Autres'}</label>
                            <NumericFormat
                                name="autres_personne_familial"
                                value={formData.autres_personne_familial ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('autres_personne_familial', values.value, 'indiv'); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.autres_personne_familial?.display_desc && (
                                <div className="note">* {displayRatios.autres_personne_familial?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="personne_succession_familial"><span className="numPoste">{displayRatios.personne_succession_familial?.num_row || '503'}</span> {displayRatios.personne_succession_familial?.label || 'Total'}</label>
                            <NumericFormat
                                readOnly
                                name="personne_succession_familial"
                                value={[formData.testaments_mandats, formData.successions, formData.autres_personne_familial].reduce((partialSum, a) => partialSum + (a || 0), 0)}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.personne_succession_familial?.display_desc && (
                                <div className="note">* {displayRatios.personne_succession_familial?.description}</div>
                            )}
                        </div>
                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>


                    <fieldset key={10} className={getPageClassName(10, true)}>
                        <legend>504 Expertises sectorielles <em style={{ fontWeight: 500 }}>(facultatif)</em></legend>

                        <div className="row">
                            <label htmlFor="agricole"><span className="numPoste">{displayRatios.agricole?.num_row || '504.1'}</span> {displayRatios.agricole?.label || 'Agricole'}</label>
                            <NumericFormat
                                name="agricole"
                                value={formData.agricole ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('agricole', values.value, 'expertises') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.agricole?.display_desc && (
                                <div className="note">* {displayRatios.agricole?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="exp_maritime"><span className="numPoste">{displayRatios.exp_maritime?.num_row || '504.2'}</span> {displayRatios.exp_maritime?.label || 'Maritime'}</label>
                            <NumericFormat
                                name="exp_maritime"
                                value={formData.exp_maritime ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('exp_maritime', values.value, 'expertises') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.exp_maritime?.display_desc && (
                                <div className="note">* {displayRatios.exp_maritime?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="donations_fiduciaires"><span className="numPoste">{displayRatios.donations_fiduciaires?.num_row || '504.3'}</span> {displayRatios.donations_fiduciaires?.label || 'Fiducie (donation fiduciaire, testament fiduciaire)'}</label>
                            <NumericFormat
                                name="donations_fiduciaires"
                                value={formData.donations_fiduciaires ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('donations_fiduciaires', values.value, 'expertises') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.donations_fiduciaires?.display_desc && (
                                <div className="note">* {displayRatios.donations_fiduciaires?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="exp_autres"><span className="numPoste">{displayRatios.exp_autres?.num_row || '504.4'}</span> {displayRatios.exp_autres?.label || 'Autres'}</label>
                            <NumericFormat
                                name="exp_autres"
                                value={formData.exp_autres ?? 0}
                                onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('exp_autres', values.value, 'expertises') }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.exp_autres?.display_desc && (
                                <div className="note">* {displayRatios.exp_autres?.description}</div>
                            )}
                        </div>

                        <div className="row">
                            <label htmlFor="exp_total"><span className="numPoste">{displayRatios.exp_total?.num_row || '504'}</span> {displayRatios.exp_total?.label || 'Total'}</label>
                            <NumericFormat
                                readOnly
                                name="exp_total"
                                value={[formData.agricole, formData.exp_maritime, formData.donations_fiduciaires, formData.exp_autres].reduce((partialSum, a) => partialSum + (a || 0), 0)}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                            {!!displayRatios.exp_total?.display_desc && (
                                <div className="note">* {displayRatios.exp_total?.description}</div>
                            )}
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>

                    <fieldset key={11} className={getPageClassName(11)}>
                        <legend>600 Statistiques salariales</legend>

                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.salaire_notaires_salaries_min?.num_row || '601'}
                                </span>
                                {' '}
                                {displayRatios.salaire_notaires_salaries_min 
                                    ? (displayRatios.salaire_notaires_salaries_min.label || 'Salaire des notaires salarié(e)s').replace('(minimum)', '').trim() 
                                    : 'Salaire des notaires salarié(e)s'}
                            </span>

                            <div className="row">
                                <label htmlFor="salaire_notaires_salaries_min">Minimum</label>
                                <NumericFormat
                                    name="salaire_notaires_salaries_min"
                                    value={formData.salaire_notaires_salaries_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_notaires_salaries_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="salaire_notaires_salaries_max">Maximum</label>
                                <NumericFormat
                                    name="salaire_notaires_salaries_max"
                                    value={formData.salaire_notaires_salaries_max}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_notaires_salaries_max', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                        </div>
                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.salaire_collab_min?.num_row || '602'}
                                </span>
                                {' '}
                                {displayRatios.salaire_collab_min 
                                    ? (displayRatios.salaire_collab_min.label || 'Salaire des collaborateur(rice)s').replace('(minimum)', '').trim() 
                                    : 'Salaire des collaborateur(rice)s'}
                            </span>

                            <div className="row">
                                <label htmlFor="salaire_collab_min">Minimum</label>
                                <NumericFormat
                                    name="salaire_collab_min"
                                    value={formData.salaire_collab_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_collab_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="salaire_collab_max">Maximum</label>
                                <NumericFormat
                                    name="salaire_collab_max"
                                    value={formData.salaire_collab_max}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_collab_max', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                        </div>
                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.salaire_avocat_min?.num_row || '603'}
                                </span>
                                {' '}
                                {displayRatios.salaire_avocat_min 
                                    ? (displayRatios.salaire_avocat_min.label || 'Salaires des d’avocats(es) et/ou autres juristes').replace('(minimum)', '').trim() 
                                    : 'Salaires des d’avocats(es) et/ou autres juristes'}
                            </span>

                            <div className="row">
                                <label htmlFor="salaire_avocat_min">Minimum</label>
                                <NumericFormat
                                    name="salaire_avocat_min"
                                    value={formData.salaire_avocat_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_avocat_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="salaire_avocat_max">Maximum</label>
                                <NumericFormat
                                    name="salaire_avocat_max"
                                    value={formData.salaire_avocat_max}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_avocat_max', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                        </div>
                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.stagiaire_notariat_min?.num_row || '604'}
                                </span>
                                {' '}
                                {displayRatios.stagiaire_notariat_min 
                                    ? (displayRatios.stagiaire_notariat_min.label || 'Salaire des stagiaires en notariat').replace('(minimum)', '').trim() 
                                    : 'Salaire des stagiaires en notariat'}
                            </span>

                            <div className="row">
                                <label htmlFor="stagiaire_notariat_min">Minimum</label>
                                <NumericFormat
                                    name="stagiaire_notariat_min"
                                    value={formData.stagiaire_notariat_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('stagiaire_notariat_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="stagiaire_notariat">Maximum</label>
                                <NumericFormat
                                    name="stagiaire_notariat"
                                    value={formData.stagiaire_notariat}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('stagiaire_notariat', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                        </div>
                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.salaire_saisonnier_min?.num_row || '605'}
                                </span>
                                {' '}
                                {displayRatios.salaire_saisonnier_min 
                                    ? (displayRatios.salaire_saisonnier_min.label || 'Salaire d’employés saisonniers').replace('(minimum)', '').trim() 
                                    : 'Salaire d’employés saisonniers'}
                            </span>

                            <div className="row">
                                <label htmlFor="salaire_saisonnier_min">Minimum</label>
                                <NumericFormat
                                    name="salaire_saisonnier_min"
                                    value={formData.salaire_saisonnier_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_saisonnier_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="salaire_saisonnier_max">Maximum</label>
                                <NumericFormat
                                    name="salaire_saisonnier_max"
                                    value={formData.salaire_saisonnier_max}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_saisonnier_max', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                        </div>
                        <div className="min-max-row">
                            <span className="row-title">
                                <span className="numPoste">
                                    {displayRatios.salaire_autre_min?.num_row || '606'}
                                </span>
                                {' '}
                                {displayRatios.salaire_autre_min 
                                    ? (displayRatios.salaire_autre_min.label || 'Salaire des salariés occupant un poste autre que notaire ou collabo.').replace(' (minimum)', '.').trim() + ' (DG, Adj. Admin, récept., marketing, etc.)'
                                    : 'Salaire des salariés occupant un poste autre que notaire ou collabo. (DG, Adj. Admin, récept., marketing, etc.)'}
                            </span>

                            <div className="row">
                                <label htmlFor="salaire_autre_min">Minimum</label>
                                <NumericFormat
                                    name="salaire_autre_min"
                                    value={formData.salaire_autre_min}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_autre_min', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            <div className="row">
                                <label htmlFor="salaire_autre_max">Maximum</label>
                                <NumericFormat
                                    name="salaire_autre_max"
                                    value={formData.salaire_autre_max}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('salaire_autre_max', values.value); }}
                                    decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" isAllowed={isValidSalary} />
                            </div>
                            {isValidYear() && (
                                <div className="note">Merci d'inscrire le taux horaire</div>
                            )}
                            
                        </div>


                        <div className="number-fields-only">

                            <div className="row">
                                <label htmlFor="taux_horaire_notaire_moins_de_5_ans"><span className="numPoste">{displayRatios.taux_horaire_notaire_moins_de_5_ans?.num_row || '607'}</span> {displayRatios.taux_horaire_notaire_moins_de_5_ans?.label || 'Lorsque vous facturez à l\'heure, quel est votre taux horaire moyen pour un notaire de moins de 5 ans d’expérience ?'}</label>
                                <NumericFormat
                                    name="taux_horaire_notaire_moins_de_5_ans"
                                    value={formData.taux_horaire_notaire_moins_de_5_ans ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('taux_horaire_notaire_moins_de_5_ans', values.value); }}
                                    decimalScale={0} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix="" />
                            </div>
                            <div className="row">
                                <label htmlFor="taux_horaire_notaire_5_a_10_ans"><span className="numPoste">{displayRatios.taux_horaire_notaire_5_a_10_ans?.num_row || '608'}</span> {displayRatios.taux_horaire_notaire_5_a_10_ans?.label || 'Lorsque vous facturez à l\'heure, quel est votre taux horaire moyen pour un notaire de 5 à 10 ans d’expérience ?'}</label>
                                <NumericFormat
                                    name="taux_horaire_notaire_5_a_10_ans"
                                    value={formData.taux_horaire_notaire_5_a_10_ans ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('taux_horaire_notaire_5_a_10_ans', values.value); }}
                                    decimalScale={0} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix="" />
                            </div>
                            <div className="row">
                                <label htmlFor="taux_horaire_notaire_plus_de_10_ans"><span className="numPoste">{displayRatios.taux_horaire_notaire_plus_de_10_ans?.num_row || '609'}</span> {displayRatios.taux_horaire_notaire_plus_de_10_ans?.label || 'Lorsque vous facturez à l\'heure, quel est votre taux horaire moyen pour un notaire de plus de 10 ans d’expérience ?'}</label>
                                <NumericFormat
                                    name="taux_horaire_notaire_plus_de_10_ans"
                                    value={formData.taux_horaire_notaire_plus_de_10_ans ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('taux_horaire_notaire_plus_de_10_ans', values.value); }}
                                    decimalScale={0} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix="" />
                            </div>
                            <div className="row">
                                <label htmlFor="taux_horaire_collaborateur"><span className="numPoste">{displayRatios.taux_horaire_collaborateur?.num_row || '610'}</span> {displayRatios.taux_horaire_collaborateur?.label || 'Lorsque vous facturez à l\'heure, quel est votre taux horaire moyen pour un(e) collaborateur(rice) ?'}</label>
                                <NumericFormat
                                    name="taux_horaire_collaborateur"
                                    value={formData.taux_horaire_collaborateur ?? 0}
                                    onValueChange={(values: { value: string }, sourceInfo: any) => { setValue('taux_horaire_collaborateur', values.value); }}
                                    decimalScale={0} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix="" />
                            </div>
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Suivant/Enregistrer" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>




                    <fieldset key={12} className={getPageClassName(12, true)}>
                        <legend>700 Tarification</legend>

                        <h5>Quel est votre forfait honoraires OU montant de base (sans taxes) pour : </h5> 
                        <div className="note">* Selon la façon dont vous facturez vos dossiers, veuillez remplir le montant forfaitaire OU le montant de base facturé pour ce dossier.</div>
                        
                        {/* --- 701 & 701.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_residentiel">
                                <span className="numPoste">{displayRatios.forfait_honoraires_residentiel?.num_row || '701'}</span> {displayRatios.forfait_honoraires_residentiel?.label || 'Montant forfaitaire de pour prêt/vente résidentiel (400 000 $ et moins)'}
                                {!!displayRatios.forfait_honoraires_residentiel?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_residentiel?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_residentiel"
                                value={formData.forfait_honoraires_residentiel ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_residentiel', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row sub-row"> {/* Optionnel: ajout d'une classe pour l'indentation si nécessaire */}
                            <label htmlFor="base_forfait_honoraires_residentiel">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_residentiel?.num_row || '701.1'}</span> {displayRatios.base_forfait_honoraires_residentiel?.label || 'Montant de base pour un prêt/vente résidentiel (400 000 $ et moins)'}
                                {!!displayRatios.base_forfait_honoraires_residentiel?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_residentiel?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_residentiel"
                                value={formData.base_forfait_honoraires_residentiel ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_residentiel', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row" style={{ paddingBottom: '20px', borderTop: '1px solid #ccc' }}></div>

                        {/* --- 702 & 702.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_testaments">
                                <span className="numPoste">{displayRatios.forfait_honoraires_testaments?.num_row || '702'}</span> {displayRatios.forfait_honoraires_testaments?.label || 'Montant forfaitaire pour deux testaments et mandats (couple) simples ?'}
                                {!!displayRatios.forfait_honoraires_testaments?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_testaments?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_testaments"
                                value={formData.forfait_honoraires_testaments ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_testaments', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row">
                            <label htmlFor="base_forfait_honoraires_testaments">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_testaments?.num_row || '702.1'}</span> {displayRatios.base_forfait_honoraires_testaments?.label || 'Montant de base pour deux testaments et mandats (couple) simples'}
                                {!!displayRatios.base_forfait_honoraires_testaments?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_testaments?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_testaments"
                                value={formData.base_forfait_honoraires_testaments ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_testaments', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '20px', borderTop: '1px solid #ccc' }}></div>

                        {/* --- 703 & 703.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_corporatif">
                                <span className="numPoste">{displayRatios.forfait_honoraires_corporatif?.num_row || '703'}</span> {displayRatios.forfait_honoraires_corporatif?.label || 'Montant forfaitaire pour le service corporatif de base ?'}
                                {!!displayRatios.forfait_honoraires_corporatif?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_corporatif?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_corporatif"
                                value={formData.forfait_honoraires_corporatif ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_corporatif', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row">
                            <label htmlFor="base_forfait_honoraires_corporatif">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_corporatif?.num_row || '703.1'}</span> {displayRatios.base_forfait_honoraires_corporatif?.label || 'Montant de base pour le service corporatif de base'}
                                {!!displayRatios.base_forfait_honoraires_corporatif?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_corporatif?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_corporatif"
                                value={formData.base_forfait_honoraires_corporatif ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_corporatif', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '20px', borderTop: '1px solid #ccc' }}></div>

                        {/* --- 704 & 704.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_feducie">
                                <span className="numPoste">{displayRatios.forfait_honoraires_feducie?.num_row || '704'}</span> {displayRatios.forfait_honoraires_feducie?.label || 'Montant forfaitaire pour le service fiducie de base ?'}
                                {!!displayRatios.forfait_honoraires_feducie?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_feducie?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_feducie"
                                value={formData.forfait_honoraires_feducie ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_feducie', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row">
                            <label htmlFor="base_forfait_honoraires_feducie">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_feducie?.num_row || '704.1'}</span> {displayRatios.base_forfait_honoraires_feducie?.label || 'Montant de base pour le service fiducie de base'}
                                {!!displayRatios.base_forfait_honoraires_feducie?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_feducie?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_feducie"
                                value={formData.base_forfait_honoraires_feducie ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_feducie', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '20px', borderTop: '1px solid #ccc' }}></div>

                        {/* --- 705 & 705.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_hypotheque">
                                <span className="numPoste">{displayRatios.forfait_honoraires_hypotheque?.num_row || '705'}</span> {displayRatios.forfait_honoraires_hypotheque?.label || 'Montant forfaitaire pour une quittance ou mainlevée - hypothèque d’un vendeur d’une propriété résidentiel ?'}
                                {!!displayRatios.forfait_honoraires_hypotheque?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_hypotheque?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_hypotheque"
                                value={formData.forfait_honoraires_hypotheque ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_hypotheque', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row">
                            <label htmlFor="base_forfait_honoraires_hypotheque">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_hypotheque?.num_row || '705.1'}</span> {displayRatios.base_forfait_honoraires_hypotheque?.label || 'Montant de base pour une quittance ou mainlevée – hypothèque d’un vendeur'}
                                {!!displayRatios.base_forfait_honoraires_hypotheque?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_hypotheque?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_hypotheque"
                                value={formData.base_forfait_honoraires_hypotheque ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_hypotheque', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '20px', borderTop: '1px solid #ccc' }}></div>

                        {/* --- 706 & 706.1 --- */}
                        <div className="row">
                            <label htmlFor="forfait_honoraires_incorporation">
                                <span className="numPoste">{displayRatios.forfait_honoraires_incorporation?.num_row || '706'}</span> {displayRatios.forfait_honoraires_incorporation?.label || 'Montant forfaitaire pour une nouvelle incorporation ?'}
                                {!!displayRatios.forfait_honoraires_incorporation?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_incorporation?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_incorporation"
                                value={formData.forfait_honoraires_incorporation ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_incorporation', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>
                        <div className="row" style={{ paddingBottom: '0',paddingTop: '0', justifyContent: 'center' }}> OU </div>
                        <div className="row">
                            <label htmlFor="base_forfait_honoraires_incorporation">
                                <span className="numPoste">{displayRatios.base_forfait_honoraires_incorporation?.num_row || '706.1'}</span> {displayRatios.base_forfait_honoraires_incorporation?.label || 'Montant de base pour une nouvelle incorporation'}
                                {!!displayRatios.base_forfait_honoraires_incorporation?.display_desc && (
                                    <span className="note"><br />* {displayRatios.base_forfait_honoraires_incorporation?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="base_forfait_honoraires_incorporation"
                                value={formData.base_forfait_honoraires_incorporation ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('base_forfait_honoraires_incorporation', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <h5>Quels sont vos honoraires approximatifs (sans taxes) pour </h5>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_hmn">
                                <span className="numPoste">{displayRatios.forfait_honoraires_hmn?.num_row || '707'}</span> {displayRatios.forfait_honoraires_hmn?.label || 'Un dossier d’homologation de mandat devant notaire ?'}
                                {!!displayRatios.forfait_honoraires_hmn?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_hmn?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_hmn"
                                value={formData.forfait_honoraires_hmn ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_hmn', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_htn">
                                <span className="numPoste">{displayRatios.forfait_honoraires_htn?.num_row || '708'}</span> {displayRatios.forfait_honoraires_htn?.label || 'Un dossier d’homologation de testament devant notaire ?'}
                                {!!displayRatios.forfait_honoraires_htn?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_htn?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_htn"
                                value={formData.forfait_honoraires_htn ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_htn', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_rpm">
                                <span className="numPoste">{displayRatios.forfait_honoraires_rpm?.num_row || '709'}</span> {displayRatios.forfait_honoraires_rpm?.label || 'En dossier d’ouverture de tutelle au majeur ?'}
                                {!!displayRatios.forfait_honoraires_rpm?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_rpm?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_rpm"
                                value={formData.forfait_honoraires_rpm ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_rpm', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_cp_div">
                                <span className="numPoste">{displayRatios.forfait_honoraires_cp_div?.num_row || '710'}</span> {displayRatios.forfait_honoraires_cp_div?.label || 'une copropritété divise'}
                                {!!displayRatios.forfait_honoraires_cp_div?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_cp_div?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_cp_div"
                                value={formData.forfait_honoraires_cp_div ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_cp_div', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_convention_actionnaire">
                                <span className="numPoste">{displayRatios.forfait_honoraires_convention_actionnaire?.num_row || '711'}</span> {displayRatios.forfait_honoraires_convention_actionnaire?.label || 'une convention d’actionnaires?'}
                                {!!displayRatios.forfait_honoraires_convention_actionnaire?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_convention_actionnaire?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_convention_actionnaire"
                                value={formData.forfait_honoraires_convention_actionnaire ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_convention_actionnaire', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_pnc">
                                <span className="numPoste">{displayRatios.forfait_honoraires_pnc?.num_row || '712'}</span> {displayRatios.forfait_honoraires_pnc?.label || 'une PNC'}
                                {!!displayRatios.forfait_honoraires_pnc?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_pnc?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_pnc"
                                value={formData.forfait_honoraires_pnc ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_pnc', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_conv_achat_vente">
                                <span className="numPoste">{displayRatios.forfait_honoraires_conv_achat_vente?.num_row || '713'}</span> {displayRatios.forfait_honoraires_conv_achat_vente?.label || 'une convention d’achat-vente (d’actions ou d’entreprises)'}
                                {!!displayRatios.forfait_honoraires_conv_achat_vente?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_conv_achat_vente?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_conv_achat_vente"
                                value={formData.forfait_honoraires_conv_achat_vente ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_conv_achat_vente', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <h5>Combien chargez-vous en</h5>
                        <div className="row">
                            <label htmlFor="forfait_honoraires_acte_techno">
                                <span className="numPoste">{displayRatios.forfait_honoraires_acte_techno?.num_row || '714'}</span> {displayRatios.forfait_honoraires_acte_techno?.label || 'un acte technologique (1h)'}
                                {!!displayRatios.forfait_honoraires_acte_techno?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_acte_techno?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_acte_techno"
                                value={formData.forfait_honoraires_acte_techno ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_acte_techno', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_reception_signature">
                                <span className="numPoste">{displayRatios.forfait_honoraires_reception_signature?.num_row || '715'}</span> {displayRatios.forfait_honoraires_reception_signature?.label || 'les frais de réception de signature devant notaires'}
                                {!!displayRatios.forfait_honoraires_reception_signature?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_reception_signature?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_reception_signature"
                                value={formData.forfait_honoraires_reception_signature ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_reception_signature', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_cc_client">
                                <span className="numPoste">{displayRatios.forfait_honoraires_cc_client?.num_row || '716'}</span> {displayRatios.forfait_honoraires_cc_client?.label || 'une copie conforme pour un client'}
                                {!!displayRatios.forfait_honoraires_cc_client?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_cc_client?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_cc_client"
                                value={formData.forfait_honoraires_cc_client ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_cc_client', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="row">
                            <label htmlFor="forfait_honoraires_cc_juriste">
                                <span className="numPoste">{displayRatios.forfait_honoraires_cc_juriste?.num_row || '717'}</span> {displayRatios.forfait_honoraires_cc_juriste?.label || 'une copie conforme pour un autre juriste'}
                                {!!displayRatios.forfait_honoraires_cc_juriste?.display_desc && (
                                    <span className="note"><br />* {displayRatios.forfait_honoraires_cc_juriste?.description}</span>
                                )}
                            </label>
                            <NumericFormat
                                name="forfait_honoraires_cc_juriste"
                                value={formData.forfait_honoraires_cc_juriste ?? 0}
                                onValueChange={(values: { value: string }) => { setValue('forfait_honoraires_cc_juriste', values.value); }}
                                decimalScale={2} fixedDecimalScale decimalSeparator="," thousandSeparator=" " suffix=" $" />
                        </div>

                        <div className="btnrow">
                            <input type="button" defaultValue="Précédent" className="back" onClick={() => submit(page - 1)} />
                            <input type="button" defaultValue="Validation" className="next" onClick={() => submit(page + 1)} />
                        </div>
                    </fieldset>


                    <fieldset key={13} className={getPageClassName(13)}>

                        <div className="p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800">
                            Merci d’avoir participé aux ratios de gestion. Le siège social vous contactera lorsque les comparatifs seront disponibles.
                        </div>

                        <legend>Indicateurs de performance</legend>
                        <div className="results">
                            <div className="title">{displayRatios.benefits_bprel?.label || 'Pourcentage profit (bénéfice) avant les prélèvements des associé(e)s'}</div>
                            <div className="result" data-value="benefits_bprel">
                                {percent.format(beneficesNetsTotal / chiffreAffairesAvTaxesTotal)}
                            </div>
                            <div className="result-details">Bénéfices Net ({money.format(beneficesNetsTotal)}) ÷ Chiffre d’affaire({money.format(chiffreAffairesAvTaxesTotal)}) </div>
                        </div>
                        <div className="results">
                            <div className="title">{displayRatios.fond_roulement?.label || 'Ratio de Fond de roulement'}</div>
                            <div className="result" data-value="fond_roulement">
                                {nb.format(formData.total_actifs / formData.total_passifs)}
                            </div>
                            <div className="result-details">Total des actifs ({money.format(formData.total_actifs)}) ÷ Total des passifs ({money.format(formData.total_passifs)})</div>
                        </div>
                       {/**
                        * TODO: la clients nous a demander de masquer ces champs et les rendre invisibles dans le rapport voici comment le réactiver 
                        // IMPORTANT a noter que présententement le Seuil de rentabilité et Point mort. on été aussi cacher pour le moment des exporttions
                        //  pour les reactiver. on dois aller dans la base de donner dans la tables : wp_ratiometa_labels et faire une recherche pour c'est deux champs
                        // : seuilRentabilite (ID= 399) et point_mort (ID = 400). on a juste a changer la category du champs. (rentability_desactiver a rentability) normalement cela devrais les rafficher
                        <div className="results">
                            <div className="title">Seuil de rentabilité</div>
                            <div className="result" data-value="seuilRentabilite">
                                {money.format(seuilRentabilite)}
                            </div>
                            <div className="result-details"><span style={{ borderBottom: '1px solid black', display: 'inline-block', padding: '0 1em' }}>Chiffre d’affaire ({money.format(ca)}) × Coûts fixes ({money.format(coutsFixes)})</span> <span style={{ display: 'inline-block', padding: '0 1em' }}>Chiffre d’affaire ({money.format(ca)}) — Coûts variables ({money.format(coutsVariables)})</span></div>
                        </div>

                        <div className="results">
                            <div className="title">Point mort</div>
                            <div className="result" data-value="point_mort">
                                {nb.format(Math.ceil((seuilRentabilite * 360) / ca))}
                            </div>
                            <div className="result-details">Le nombre de jours nécessaires pour atteindre le seuil de rentabilité.<br/>Seuil de rentabilité ({money.format(seuilRentabilite)}) × 360 ÷ Chiffre d’affaires ({money.format(ca)})</div>
                        </div>
                        */}     

                        <div className="results">
                            <div className="title">{displayRatios.ca_benefits?.label || "Chiffre d’affaire qui aurait permis de dégager un bénéfice net de 15% après les prélèvements des associé(e)s"}</div>
                            <div className="result" data-value="ca_benefits">
                                {money.format(totalExpenses - notaryAssocSalary)}
                            </div>
                            <div className="result-details">Total des dépenses ({money.format(totalExpenses)}) - Prélèvements des associé(e)s ({money.format(notaryAssocSalary)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.recevable_sur_facturation_pourcent?.label || "Pourcentage des recevables sur facturation"}</div>
                            <div className="result" data-value="perc_recevable">
                                {percent.format(formData.recevables / ca)}
                            </div>
                            <div className="result-details">Recevables ({money.format(formData.recevables)}) ÷ Chiffre d'affaires ({money.format(ca)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.delai_perception?.label || "Délai de perception"}</div>
                            <div className="result" data-value="delay_percept">
                                {nb.format(formData.recevables / facturationTotal * 365)} jours
                            </div>
                            <div className="result-details">Recevables ({money.format(formData.recevables)}) ÷ Facturation ({money.format(facturationTotal)}) × 365</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.tec_sur_facturation_pourcent?.label || "Pourcentage des travaux en cours (TEC) sur facturation"}</div>
                            <div className="result" data-value="tec_sur_facturation_pourcent">
                                {percent.format(formData.travaux_en_cours / ca)}
                            </div>
                            <div className="result-details">TEC ({money.format(formData.travaux_en_cours)}) ÷ Chiffre d'affaires ({money.format(ca)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.perc_salary?.label || "Pourcentage salaires sur chiffre d’affaires"}</div>
                            <div className="result" data-value="perc_salary">
                                {percent.format(salary / ca)}
                            </div>
                            <div className="result-details">Salaires ({money.format(salary)}) ÷ Chiffre d’affaire ({money.format(ca)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.perc_notaries?.label || "Pourcentage salaires notaires sur chiffre d’affaires"}</div>
                            <div className="result" data-value="perc_notaries">
                                {percent.format(notarySalary / ca)}
                            </div>
                            <div className="result-details">Salaires des notaires ({money.format(notarySalary)}) ÷ Chiffre d’affaire ({money.format(ca)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.avg_notary?.label || "Salaires et avantages - moyenne par notaire salarié"}</div>
                            <div className="result" data-value="avg_notary">
                                {money.format(notarySalary / formData.nb_notaires_salaries)}
                            </div>
                            <div className="result-details">Salaires des notaires ({money.format(notarySalary)}) ÷ Nombre de notaires salariés ({nb.format(formData.nb_notaires_salaries)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.avg_collab?.label || "Salaires et avantages - moyenne par collabo"}</div>
                            <div className="result" data-value="avg_collab">
                                {money.format(formData.salaire_coll / formData.nb_employes)}
                            </div>
                            <div className="result-details">Salaires des collaborateurs ({money.format(formData.salaire_coll)}) ÷ Nombre de collaborateurs ({formData.nb_employes})</div>

                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.cases_month?.label || "Dossiers / mois"}</div>
                            <div className="result" data-value="cases_month">
                                {nb.format(formData.nb_dossiers / 12)}
                            </div>
                            <div className="result-details">Nombre de dossiers ({formData.nb_dossiers}) ÷ 12</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.minutes_month?.label || "Minutes / mois"}</div>
                            <div className="result" data-value="minutes_month">
                                {nb.format(formData.nb_minutes / 12)}
                            </div>
                            <div className="result-details">Nombre de minutes ({formData.nb_minutes}) ÷ 12</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.cases_notary_year?.label || "Dossiers / notaire / année"}</div>
                            <div className="result" data-value="cases_notary_year">
                                {/* previous calculation : {nb.format(formData.nb_dossiers / formData.nb_notaires_salaries)} */}
                                {nb.format(formData.nb_dossiers / (formData.nb_notaires_salaries + formData.nb_notaires_associes))}
                            </div>
                            <div className="result-details">Nombre de dossiers ({formData.nb_dossiers}) ÷ Nombre de notaires ({nb.format(formData.nb_notaires_salaries + formData.nb_notaires_associes)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.minutes_notary_year?.label || "Minutes / notaire / année"}</div>
                            <div className="result" data-value="minutes_notary_year">
                                {/* previous calculation : {nb.format(formData.nb_minutes / formData.nb_notaires_salaries)} */}
                                {nb.format(formData.nb_minutes / (formData.nb_notaires_salaries + formData.nb_notaires_associes))}
                            </div>
                            <div className="result-details">Nombre de minutes ({formData.nb_minutes}) ÷ Nombre de notaires ({nb.format(formData.nb_notaires_salaries + formData.nb_notaires_associes)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.avg_cost_case?.label || "Coût moyen / dossier"}</div>
                            <div className="result" data-value="avg_cost_case">
                                {money.format(totalExpenses / formData.nb_dossiers)}
                            </div>
                            <div className="result-details">Total des dépenses ({money.format(totalExpenses)}) ÷ Nombre de dossiers ({formData.nb_dossiers})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.ca_cases?.label || "Chiffre d’affaires (CA) / dossier"}</div>
                            <div className="result" data-value="ca_cases">
                                {money.format(ca / formData.nb_dossiers)}
                            </div>
                            <div className="result-details">Chiffre d’affaire ({money.format(ca)}) ÷ Nombre de dossiers ({formData.nb_dossiers})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.ca_minutes?.label || "Chiffre d’affaires (CA) / minute"}</div>
                            <div className="result" data-value="ca_minutes">
                                {money.format(ca / formData.nb_minutes)}
                            </div>
                            <div className="result-details">Chiffre d’affaire ({money.format(ca)}) ÷ Nombre de minutes ({formData.nb_minutes})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.collab_by_notary?.label || "Nombre de collaborateurs par notaire"}</div>
                            <div className="result" data-value="collab_by_notary">
                                {nb2.format(formData.nb_employes / (formData.nb_notaires_salaries + formData.nb_notaires_associes))}
                            </div>
                            <div className="result-details">Nombre de collaborateurs ({nb.format(formData.nb_employes)}) ÷ Nombre de notaires ({nb.format(formData.nb_notaires_salaries + formData.nb_notaires_associes)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.avg_ca_notary?.label || "Chiffre d’affaires moyen par notaire"}</div>
                            <div className="result" data-value="avg_ca_notary">
                                {money.format(ca / (formData.nb_notaires_salaries + formData.nb_notaires_associes))}
                            </div>
                            <div className="result-details">Chiffre d’affaire ({money.format(ca)}) ÷ Nombre de notaires ({nb.format(formData.nb_notaires_salaries + formData.nb_notaires_associes)})</div>
                        </div>

                        <div className="results">
                            <div className="title">{displayRatios.avg_ca_collab?.label || "Chiffre d’affaires moyen par collaborateur (trice)"}</div>
                            <div className="result" data-value="avg_ca_collab">
                                {money.format(ca / formData.nb_employes)}
                            </div>
                            <div className="result-details">Chiffre d’affaire ({money.format(ca)}) ÷ Nombre de collaborateur ({formData.nb_employes})</div>
                        </div>
                        {/* 
                        <div className="results">
                            <div className="title">Coût par heure facturable</div>
                            <div className="result" data-value="cost_per_hour">
                                {money.format((totalExpenses - formData.depense_debourses_dossiers) / ((formData.nb_minutes / 60) * (formData.nb_notaires_salaries + formData.nb_notaires_associes)))}/h
                            </div>
                            <div className="result-details"><span style={{ borderCollapse: 'collapse', display: 'inline-block', padding: '0 1em' }}>Total des dépenses ({money.format(totalExpenses)}) - Débours ({money.format(formData.depense_debourses_dossiers)}) </span><span style={{ borderCollapse: 'collapse', borderTop: '1px solid black', display: 'inline-block', padding: '0 1em' }}> Nombre de minutes({formData.nb_minutes}) ÷ 60 × Nombre de notaires ({nb.format(formData.nb_notaires_salaries + formData.nb_notaires_associes)})</span></div>
                        </div>

                        <div className="results">
                            <div className="title">Taux horaire moyen (honoraires par heure facturable)</div>
                            <div className="result" data-value="avg_rate_by_hour">
                                {money.format(honoraires / formData.nb_minutes / 60)}/h
                            </div>
                            <div className="result-details">Honoraires ({money.format(honoraires)}) ÷ Nombre de minutes ({formData.nb_minutes}) ÷ 60</div>

                        </div>
                        */}
                        <div className="results">
                            <div className="title">{displayRatios.taux_de_roulement?.label || "Taux de roulement"}</div>
                            <div className="result" data-value="taux_de_roulement">
                                {percent.format(formData.nb_employes_depart / (formData.nb_notaires_associes + formData.nb_notaires_salaries + formData.nb_employes + formData.nb_avocats + formData.nb_saisonniers + formData.nb_autre))}
                            </div>
                            <div className="result-details">Nombre de départs({formData.nb_employes_depart}) ÷ Nombre d’employés ({(formData.nb_notaires_associes + formData.nb_notaires_salaries + formData.nb_employes + formData.nb_avocats + formData.nb_saisonniers + formData.nb_autre)}) </div>
                        </div>


                        <div className="btnrow">
                            <input type="button" defaultValue="Modifier" className="back" onClick={() => submit(0)} />
                            <input type="button" defaultValue="Exporter le ratio" className="next" onClick={exportRatio} />
                        </div>


                    </fieldset>

                </form>

                <div className="sidebar">
                    <div className="page-index">Page {page + 1} / {pages.length}</div>
                    <nav className="page-list">
                        {
                            pages.map((page: any) => {
                                return (
                                    <li key={page.index} className={getIsActive(page.index)} onClick={e => maybeSetPage(page.index)}>{page.label}</li>
                                )
                            })
                        }
                    </nav>
                </div>
            </div >
        </>
    );
}

export default RatioForm;